export default {
    id: "EU IA",
    dashboard: "Painel",
    warning: "Aviso",
    users: "Usuários",
    farms: "Fazendas",
    animals: "animais",
    action: "Ação",
    actionList: "Lista de Ação",
    drugInventory: "Inventário de Medicamentos",
    inseminatorStatistics: "Estatísticas do Inseminador",
    organizationNTR: "Organização NTR",
    genotypePerformance: "Desempenho do genótipo",
    semenAutomation: "Automação de sêmen",
    activityLogs: "Registro de atividade",
    username: "Nome de usuário",
    title: "Título",
    deactivated: "Desativado",
    name: "Nome",
    email: "E-mail",
    emailAddress: "Endereço de email",
    mobileNum: "Número de telemóvel",
    emailOrMobile: "E-mail/Celular",
    role: "Papel",
    roles: "Funções",
    department: "Departamento",
    status: "Status",
    pages: "Páginas",
    departments: "Departamentos",
    password: "Senha",
    cancel: "Cancelar",
    submit: "Enviar",
    error: "erro",
    success: "sucesso",
    Browse: "Navegar",
    orDropYourFileCsvXlsXlsxHere: "ou solte seu arquivo (CSV, XLS, XLSx) aqui",
    search: "Procurar",
    apply: "Aplicar",
    select: "Selecione",
    previous: "Anterior",
    mandatory: "Obrigatório",
    dropYourFileHere: "ou solte seu arquivo (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) aqui",
    restoreDefault: "Restaurar padrão",
    pending: "Pendente",
    completed: "Concluído",
    remove: "Remover",
    update: "Atualizar",
    removeFile: "Remover arquivo",
    uploadFile: "Subir arquivo",
    pleaseChoosePreferedLanguage: "Por favor, escolha o seu idioma preferido",
    edit: "Editar",
    activate: "Ativar",
    deactivate: "Desativar",
    recievedOrders: "Pedidos Recebidos",
    chartRepresentation: "Representação gráfica",
    nameIsRequired: "O nome é obrigatório",
    export: "Exportar",
    noFilesAvailable: "NENHUM ARQUIVO DISPONÍVEL",
    selectDepartmentToshowRoles: "Selecione um departamento para mostrar as funções",
    selectDepartmentWithActiveRoles: "Selecione um departamento com funções ativas",
    nameCanContainOnlyAlphabets: "O nome pode conter apenas alfabetos",
    nameMustBeLessThan15Chars: "O nome deve ter menos de 30 caracteres",
    emailRequired: "O e-mail é obrigatório",
    invalidEmailFormat: "Formato de email inválido",
    mobNumReq: "O número do celular é obrigatório",
    invalidMobFormat: "Formato de número de celular inválido.",
    passwordRequired: "Senha requerida",
    departmentReq: "O departamento é obrigatório",
    roleReq: "A função é obrigatória",
    unableToUpdate: "Não foi possível atualizar",
    orignalName: "Nome original",
    uploadedDate: "Data de upload",
    fileName: "Nome do arquivo",
    importNum: "Número de importação",
    languagePreferences: "Preferência de idioma",
    pleaseTryAgainAfterSometime: "Por favor, tente depois de algum tempo",
    noChanges: "Sem alterações",
    nothingchanged: "Nada mudou",
    pleaseChooseAnImageFile: "Escolha um arquivo de imagem",
    fileIsTooBigSelectUnder1MB: "Seu arquivo é muito grande! ",
    phoneShouldHave10Chars: "O telefone deve ter 10 caracteres",
    onlyCSVAllowed: "Apenas o arquivo CSV é permitido",
    loadingPleaseWait: "Carregando, por favor espere",
    manager: "gerente",
    administrator: "administrador",
    Comingsoon: "Em breve",
    totalAnimals: "Total de Animais",
    receivedOrders: "Pedidos Recebidos",
    drugs: "Drogas",
    detailedAnalysis: "Análise detalhada",
    barGraphRepOfActiveUsersAndDeactivateUsers: "Representação em gráfico de barras de usuários ativos e usuários inativos",
    barGraphRepOfRegAnimalsVsFarm: "Representação em Gráfico de Barras de Animais Registrados Vs Fazenda",
    roleNumber: "Número da função",
    roleName: "Nome do papel",
    active: "Ativo",
    inactive: "Inativo",
    admin: "Administrador",
    addRole: "Adicionar função",
    addRoles: "Adicionar funções",
    permissions: "Permissões",
    sr: "Sr.",
    moduleName: "nome do módulo",
    view: "Visualizar",
    deptNo: "Nº do Departamento",
    selectByCategory: "Selecione por categoria",
    weeklyAnalytics: "Análise semanal",
    pregnancy: "Gravidez",
    analytics: "Análise",
    calendar: "Calendário",
    productName: "Nome do Produto",
    volumeSold: "Volume Vendido",
    recordPoints: "Pontos de registro",
    inStock: "Em estoque",
    revenue: "Receita",
    stockStatus: "Status do Estoque",
    barChart: "Gráfico de barras",
    lineChart: "Gráfico de linha",
    indexReturns: "Retornos do Índice",
    chart: "Gráfico",
    time: "tempo",
    production: "Produção",
    customization: "Costumização",
    recordsPerPage: "Registros por página",
    noDataAvailable: "Nenhum dado disponível",
    reporting: "Comunicando",
    optional: "Opcional",
    note: "Observação",
    notes: "Notas",
    date: "Data",
    kG: "KG",
    weight: "peso",
    type: "Tipo",
    lessthan3Month: "<3 meses",
    lessthan6Month: "<6 meses",
    lessthan7Month: "<7 meses",
    lastWeek: "Semana passada",
    thisWeek: "Essa semana",
    lessthanOneYear: "<1 anos",
    lessthanTwoYear: "<2 anos",
    lessthanThreeYear: "<3 anos",
    lessthanFourYear: "<4 anos",
    yes: "Sim",
    no: "Não",
    of: "de",
    notSpecified: "Não especificado",
    days: "dias",
    day: "dia",
    aDay: "um dia",
    years: "anos",
    year: "ano",
    unit: "unidade",
    units: "Unidades",
    to: "para",
    profile: "Perfil",
    logOut: "Sair",
    Unit: "Unidade",
    otherSettings: "Outros ajustes",
    somethingWentWrong: "algo deu errado.",
    toDo: "Pendência",
    loadingData: "Carregando dados...",
    taskNumber: "Número da Tarefa",
    taskName: "Nome da tarefa",
    startDate: "Data de início",
    dueDate: "Data de vencimento",
    reason: "Razão",
    quantity: "Quantidade",
    cost: "Custo",
    noRecordFound: "Nenhum Registro Encontrado",
    dailyUpdates: "Atualizações diárias",
    weeklyUpdates: "Atualizações semanais",
    moduleAccessed: "Módulo Acessado",
    typesOfAccess: "Tipos de acesso",
    userId: "ID do usuário",
    lastLogin: "Último Login",
    terminalID: "Identificação do terminal",
    geographicalAccessPoint: "Ponto de Acesso Geográfico",
    iPAddress: "Endereço de IP",
    fileAccessed: "Arquivo Acessado",
    functionAccessed: "Função acessada",
    webPageURL: "URL da página da Web",
    accessType: "Tipo de acesso",
    unsuccessfulLoginAttempts: "Tentativas de login sem sucesso",
    customerAddress: "Endereço do cliente",
    orderdate: "Data do pedido",
    postageDate: "Data de postagem",
    postID: "ID da postagem",
    packingTechnician: "Técnico de embalagem",
    packingTechnicia: "Técnico de embalagem",
    packEdit: "Pacote Editar",
    batchNumber: "Número do lote",
    collectionTechnician: "Técnico de cobrança",
    collectionTechnicia: "Técnico de cobrança",
    preparationTechnicia: "Técnico de Preparação",
    preparationTechnician: "Técnico de Preparação",
    approvedManually: "Aprovado manualmente",
    researcher: "investigador",
    dateOfApproval: "Data de aprovação",
    approvalEdit: "Aprovação Editar",
    searchByAllExceptDate: "Pesquisar por todos, exceto data",
    approval: "Aprovação",
    collection: "Coleção",
    postage: "Postagem",
    pack: "Pacote",
    straws: "canudos",
    createdAt: "Criado em",
    sireID: "ID do pai",
    economicIndexValue: "Valor do índice econômico",
    latestCollectionDate: "Última data de coleta",
    locationId: "Identificação do local",
    lastUpdated: "Ultima atualização",
    print: "Imprimir",
    save: "Salvar",
    tax: "Imposto",
    phoneNo: "Telefone não",
    exportAsPDF: "Exportar como PDF",
    statusUpdated: "Estado atualizado",
    statusNotUpdated: "Estado não atualizado",
    inProgress: "Em andamento",
    assignedTo: "Atribuído a",
    taskId: "ID da tarefa",
    createdDate: "Data de criação",
    numberOfAnimals: "Número de animais",
    healthRecordSubmittedSuccess: "Registro de saúde enviado com sucesso",
    healthRecordSubmitted: "Registro de saúde enviado.",
    InseminationRecordSubmittedSuccesful: "Registro de inseminação enviado com sucesso",
    inseminationRecordSubmitted: "Registro de inseminação enviado.",
    actionListDailyTask: "Lista de Ações - Tarefa Diária",
    sinceLastYear: "Desde o ano passado",
    sinceLastQuarter: "Desde o Último Trimestre",
    sinceLastMonth: "Desde o último mês",
    sinceLastWeek: "Desde a semana passada",
    drugWithdrawPeriod: "Período de Retirada do Medicamento",
    diagnosisName: "Nome do diagnóstico",
    animalWithNoGenetype: "Este animal não possui dados de Genótipo cadastrados. ",
    nameOfPreviousOwner: "Nome do proprietário anterior",
    avatarSize: "O tamanho do avatar deve ser inferior a 1 MB!",
    testDestination: "Destino de teste",
    animalNotAdded: "Animal não adicionado",
    registerationSuccessful: "Registro bem-sucedido",
    backToAnimalList: "Voltar para a lista de animais",
    addAnotherAnimal: "Adicionar outro animal",
    animalDetailsUpdated: "Detalhes do animal atualizados com sucesso",
    animalUpdatedSuccessfully: "Animal atualizado com sucesso",
    animalNotUpdated: "Animal Não Atualizado",
    notMember: "Não é um membro?",
    requestAccess: "Solicitar acesso",
    typePassword: "Por favor, digite a senha.",
    minChars: "mínimo de 6 caracteres",
    typeConfirmPassword: "digite confirme a senha",
    passConfig: "A confirmação da senha não corresponde.",
    invalidEmailMobile: "Formato de e-mail/celular inválido",
    passwordNotEmpty: "A senha não pode estar vazia",
    passwordLength: "O comprimento da senha não pode ser inferior a 8 caracteres",
    cityVillage: "Cidade / Aldeia",
    districtRegion: "Distrito, região",
    alreadyHaveAnAccount: "Já tem uma conta?",
    genetypeUpdated: "Genotipo atualizado",
    genetypeNotUpdated: "Genotipo não atualizado",
    sellTrade: "Vender/Trocar",
    milkingDevon: "Estoque de criação de leite de Devon para venda",
    detailedDescription: "Descrição detalhada",
    longPara: "Novilhas e vacas American Milking Devon Bulls. ",
    contactSeller: "Entre em contato com o vendedor",
    enterListingTitle: "Digite o título da listagem",
    livestocktype: "Tipo de gado",
    uploadImage: "Carregar uma imagem",
    mobilePhone: "Número de celular",
    myLivestock: "meu gado",
    livestockObservations: "Observações de Gado",
    selectFromRegisteredAnimals: "Selecione na lista de animais registrados",
    selectOption: "Selecione a opção",
    selectTypeObservation: "Selecione o tipo de observação",
    attachVeteinaryDocument: "Anexar Documento Veterinário",
    addsensorReading: "Adicionar leitura do sensor",
    myDocument: "Meus documentos",
    enterAKeyword: "Insira uma palavra-chave",
    documentType: "tipo de documento",
    registerEditLivestock: "Registrar/Editar Gado",
    editLivestockProfile: "Editar perfil do gado",
    copy: "cópia de",
    dateOfRegister: "Data de Registro",
    livestockType: "Tipo de gado",
    registerNewLivestock: "Registrar Novo Gado",
    enterUniqueTag: "Insira a tag exclusiva",
    color: "Cor",
    gender: "Gênero",
    male: "Macho",
    female: "Fêmea",
    damm: "Barragem",
    siree: "Pai",
    dateOfSaleAuction: "Data de Venda/Leilão de Venda",
    auctionRecord: "Registro de leilão da lista de óbitos",
    distinguishingFeatures: "Características distintas",
    keywordListing: "Palavra-chave ou ID da listagem",
    adType: "Tipo de anúncio",
    activeListingFund: "1 listagem ativa encontrada",
    setupSensors: "Configurar sensores",
    serialNumber: "Número de série",
    sensorLocation: "Localização do Sensor",
    sensorType: "Tipo de Sensor",
    installationDate: "Data de instalação",
    ExpirationDate: "Data de validade",
    addGeo: "Adicionar geolocalização",
    addMoreSensors: "Adicionar mais sensores",
    trackAndTrace: "Seguir e rastrear",
    createNewShipment: "Criar uma nova remessa",
    workflowReference: "Referência de fluxo de trabalho",
    invoiceDate: "Data da fatura",
    trackShipment: "Rastrear Remessa",
    totalShipments: "Remessas totais",
    activeShipment: "Remessas ativas",
    completedObjectives: "Objetivos Concluídos",
    processedPayments: "Pagamentos Processados",
    pointOfDestination: "Ponto de Destino",
    sellerInformation: "Informações do vendedor",
    selectSellerConsignor: "Selecione o vendedor/consignador",
    pointOfOrigin: "Ponto de origem",
    buyerInfo: "Informações do comprador",
    selectBuyerConsignor: "Selecione o comprador/consignador",
    addSensorTriggers: "Adicionar acionadores de sensor",
    processPayments: "Processar pagamentos",
    defineShippingContract: "Definir contrato de envio",
    addDigitize: "Adicionar",
    currentlyOnFarm: "Atualmente na Fazenda",
    addSire: "Adicionar pai",
    addApproval: "Adicionar aprovação",
    addCollection: "Adicionar coleção",
    addStraws: "Adicionar canudos",
    addPack: "Adicionar pacote",
    addPostage: "Adicionar postagem",
    searchBySire: "Pesquisar por pai",
    anyDataChangeMightBeLost: "Quaisquer alterações de dados podem ser perdidas",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "Deseja salvar ou deseja sair sem salvar",
    leave: "Deixar",
    stay: "Ficar",
    animalFarm: "Fazenda de animais",
    animalFarmH: "Fazenda de animais",
    animalOrigin: "Origem Animal",
    animalOriginH: "Origem Animal",
    farmOfOrigin: "Fazenda de Origem",
    farmOfOriginH: "Fazenda de Origem",
    selectFarm: "Selecione Fazenda",
    searchFarm: "Pesquisar Fazenda",
    confirmation: "Confirmação",
    proceed: "Continuar",
    ok: "OK",
    animal: {
      tagH: "Marcação",
      tagNumberH: "Número da etiqueta: você pode adicionar cor e número. ",
      goveRegNoH: "Detalhes de identificação que podem incluir o nome e endereço do indivíduo, o agente do indivíduo para o serviço de processo, a localização da atividade a ser realizada e uma descrição do serviço que o indivíduo fornece.",
      birthWeightH: "Peso ao Nascer do Bezerro",
      birthEaseH: "O nascimento no gado é um processo natural, mas às vezes pode haver problemas de nascimento onde a barragem precisa de ajuda do fazendeiro/pastor.",
      birthFarmH: "Fazenda de origem animal/nascimento.",
      surrogateDamH: "O ID da vaca fêmea na qual o óvulo fertilizado de um macho doador e de uma fêmea doadora é implantado para seu desenvolvimento posterior.",
      ownerH: "Este é o nome do dono do animal.",
      damH: "O ID do progenitor/mãe do animal.",
      sireH: "O ID do pai/pai masculino do animal.",
      breedH: "Uma raça é um grupo específico de animais domésticos com aparência homogênea (fenótipo), comportamento homogêneo e/ou outras características que os distinguem de outros organismos da mesma espécie.",
      conceptionMethodH: "Como o animal foi concebido.",
      genderH: "Gênero do animal.",
      dobH: "Data de nascimento do animal.",
      operatorH: "O nome da pessoa que preenche as informações deste animal.",
      removalFarmH: "Animal Removido Fazenda ",
      dateOfRemovalH: "Data de remoção do animal",
      destinationOfRemoval: "Local de destino do animal removido",
      reasonOfRemovalH: "Motivo da remoção do animal",
      trackingNumberH: "Número atribuído ao animal quando o animal é removido",
      brandH: "Marca-Simplesmente uma marca permanente que foi queimada na vaca.",
      tattoH: "Tatuagem em animal.",
      hornStatusH: "Se o animal é descornado.",
      animalOriginH: "O país de origem do animal.",
      previousOwnerH: "Nome do dono anterior do animal, caso seja adulto.",
      twinH: "Este campo informa se o animal tem gêmeos ou não.",
      regBreedAssoNoH: "Inscrições em Associações/Sociedades da raça.",
      breedAssoNameH: "Nome das Associações/Sociedades onde o animal foi registrado",
      breederH: "Este é o nome da organização que forneceu o animal.",
      breeder: "Criador",
      noteH: "Nota(s) importante(s) sobre o animal.",
      accuracyWeight_for_field: "Peso de precisão",
      conception: "Concepção",
      addAnAnimal: "Adicionar um animal",
      addAnimal: "Adicionar animal",
      registerAnAnimal: "Registrar um Animal",
      uploadAnAnimal: "Carregar um animal",
      animalRegistration: "Registro de Animais",
      animalDetails: "Detalhes do animal",
      tag: "Marcação",
      tagNumber: "Número da etiqueta",
      govtRegNumber: "Governo ",
      birthWeight: "Peso ao nascer",
      birthEase: "facilidade de nascimento",
      birthFarm: "Fazenda Nascimento",
      surrogateDam: "barragem substituta",
      owner: "Proprietário",
      ownershipType: "Tipo de propriedade",
      animalDiseaseRecord: "Registro de Doença Animal",
      govtReg: "Governo ",
      regDate: "Data Reg",
      dam: "Barragem",
      sire: "Pai",
      heifer: "Novilha",
      steer: "Dirigir",
      calf: "Panturrilha",
      farmHerd: "Fazenda/Rebanho",
      femaleCalf: "Bezerro Fêmea",
      maleCalf: "bezerro macho",
      newCalves: "Bezerros Novos",
      breed: "Raça",
      conceptionMethod: "Método de concepção",
      gender: "Gênero",
      dateOfBirth: "Data de nascimento",
      operator: "Operador",
      animalRemovedFarm: "Animal Removido Fazenda",
      dateOfAnimalRemoval: "Data da Remoção do Animal",
      destinationOfRemovedAnimal: "Destino do Animal Removido",
      reasonOfRemoval: "Motivo da Remoção",
      optionalAnimalInformation: "Informação opcional do animal",
      animalPicture: "imagem animal",
      trackingNumber: "Numero de rastreio",
      brand: "Marca",
      tatto: "Tatuagem",
      hornStatus: "Estado da Buzina",
      animalOrigin: "Origem Animal",
      previosOwner: "Proprietário anterior",
      twin: "Gêmeo",
      InABreedAssociation: "Reg.",
      nameOfBreedAssociations: "Nome das Associações de Raças",
      breedAssociations: "Associações de Raças",
      breederSupplier: "Criador (Fornecedor)",
      importAnimal: "Importar animal",
      loadingAnimals: "Carregando Animais... Por favor aguarde",
      totalRegAnimals: "Registro Total ",
      totalPregnantAnimals: "Total de Animais Grávidos",
      pregnantAnimalHistory: "Histórico de Animais Grávidos",
      dailyAnimalPregnancyUpdates: "Atualizações diárias sobre a gravidez de animais",
      animalHistory: "História Animal",
      dailyAnimalUpdates: "Atualizações diárias de animais",
      totalPregnant: "Grávida Total",
      totalNewBorn: "Recém-nascido total",
      searchByIDGOVRegTag: "Pesquise por ID, registro GOV e etiqueta",
      noANIMALAVAILABLE: "NENHUM ANIMAL DISPONÍVEL",
      associationNumber: "Número de associação",
      associationName: "Nome da associação",
      destinationName: "Nome do destino",
      plastic: "Plástico",
      metal: "Metal",
      naturalMating: "Acasalamento Natural",
      artificialInsemination: "Inseminação artificial",
      embryoTransfer: "Transferência de embriões",
      noAssistance: "Sem assistência",
      someAssistance: "Alguma Assistência",
      mechanicalAssistance: "Assistência Mecânica",
      aCesareanSection: "Uma cesariana",
      abnormalDelivery: "Entrega Anormal",
      male: "Macho",
      female: "Fêmea",
      sale: "Oferta",
      slaughter: "abate",
      death: "Morte",
      theft: "Roubo",
      other: "Outro",
      horned: "com chifres",
      polled: "Sondagem",
      dehorned: "descornado",
      details: "Detalhes",
      performance: "Desempenho",
      geneticWorth: "valor genético",
      healthRecord: "Histórico de saúde",
      genotypeData: "Dados do Genótipo",
      reminders: "Lembretes",
      activityLog: "Registro de atividade",
      activityLogDetails: "Detalhes do registro de atividades",
      editAnimal: "Editar animal",
      familyInfo: "Informações da família",
      breedInfo: "Informações da raça",
      identification: "Identificação",
      removalInfo: "Informações de Remoção",
      iDOfAnimalDam: "ID da mãe do animal.",
      iDOfAnimalSire: "ID do pai do animal.",
      iDOfDamEmbryoUsed: "ID da mãe cujo embrião foi usado.",
      animalHasATwinOrNot: "Se o animal tem um irmão gêmeo ou não.",
      breedType: "Tipo de Raça",
      breedOfTheAnimal: "Esta é uma raça do animal.",
      regBreedAssociations: "Inscrições em Associações/Sociedades da raça.",
      nameOfAssociationsSocieties: "Nome das Associações/Sociedades onde o animal foi registrado.",
      nameOfTheOrgSuppliedAnimal: "Este é o nome da organização que forneceu o animal.",
      countryOriginAnimal: "O país de origem do animal.",
      birthFarmID: "ID da fazenda de nascimento",
      farmIDAnimalBorn: "O ID da fazenda onde o animal nasceu.",
      currentOwner: "Proprietário atual",
      nameOfOwnerAnimal: "Este é o nome do dono do animal.",
      registrationDate: "data de registro",
      previousOwner: "Antigo proprietário",
      nameOfOperator: "Nome do operador",
      dateAnimalRemoved: "Data em que o animal é removido.",
      destinationPlaceRemovedAnimal: "Local de destino do animal removido",
      namePersonFillAnimalInformation: "O nome da pessoa que preenche as informações deste animal.",
      reasonOfAnimalRemoval: "Motivo da remoção do animal",
      reasonWhyTheAnimalIsRemoved: "Razão pela qual o animal é removido",
      processingDate: "Processando dados",
      DateInformationFilledChanged: "A data em que as informações atuais foram preenchidas ou alteradas.",
      animalID: "Identificação do animal",
      UniqueIdAnimal: "Esta é a identificação única do animal.",
      plasticTagNumber: "Número da etiqueta de plástico",
      numberAnimalTag: "Número da tag Animal.",
      rFTagNumber: "Número da etiqueta de RF",
      numberAnimalRFTag: "Número da etiqueta de RF do animal.",
      govtRegNumb: "Governo ",
      govtRegistrationNumber: "Detalhes de identificação que podem incluir o nome e endereço do indivíduo, o agente do indivíduo para o serviço de processo, a localização da atividade a ser realizada e uma descrição do serviço que o indivíduo fornece.",
      numberAssignedAnimalIsRemoved: "O número de rastreamento é um dos IDs dos animais usados ​​para rastrear a atividade do animal.",
      dateOfAnimalRegistration: "Data de registro do animal",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "Marca-Simplesmente uma marca permanente que foi queimada na vaca.",
      tattoOnAnimal: "Tatuagem em animal.",
      whetherTheAnimalIsDehorned: "Se o animal é descornado.",
      milkingAnimals: "Animais leiteiros",
      studAnimals: "Reprodutores",
      animalInseminationRecord: "Registro de Inseminação Animal",
      numOfStrawsOrdered: "Número de canudos pedidos",
      totalNumOfStraws: "Número Total de Canudos",
      strawId: "Identificador de canudo",
      addSireAutomation: "Adicionar automação de pai",
      addApprovalAutomation: "Adicionar Automação de Aprovação",
      addCollectionAutomation: "Adicionar automação de coleta",
      addStrawsAutomation: "Adicionar automação de canudos",
      addPackAutomation: "Adicionar Automação de Pacote",
      addPostageAutomation: "Adicionar automação de postagem",
      searchBySire: "searchBySire",
      numberOfProgenies: "Número de Progênies",
      sireEdit: "Senhor Editar",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "Pesquise por ID do canudo, Número total de canudos, Número do lote e Id do local",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "Pesquise por Pack Id, Número de canudos pedidos, Packing Technicia",
      searchByCollectionAndPreparationTechnicia: "Pesquise por técnica de coleta e preparação",
      registerSemenAutomation: "Registrar automação de sêmen",
      addSemenAutomation: "Adicionar automação de sêmen",
      strawAutomationRegistered: "Straw Automation Registrado",
      strawAutomationRegisteredNotRegistered: "Straw Automation Registrado não Registrado",
      sireAutomationRegistered: "Sire Automation registrado",
      sireAutomationNotRegistered: "Sire Automation não registrado",
      postageAutomationIsRegistered: "Automação de postagem é registrada",
      postageAutomationNotRegistered: "Automação de postagem não registrada",
      packAutomationIsRegistered: "A Automação de Pacotes é Registrada",
      packAutomationNotRegistered: "Automação de pacote não registrado",
      postageAutomationIsUpdated: "Automação de postagem é atualizada",
      postageAutomationNotUpdated: "Automação de postagem não atualizada",
      packAutomationIsUpadted: "A Automação de Pacotes foi Atualizada",
      packAutomationNotUpadted: "Automação de pacote não atualizada",
      collectionAutomationUpdated: "Automação de cobrança atualizada",
      collectionAutomationNotUpdated: "Automação de cobrança não atualizada",
      approvalAutomationIsUpdated: "Automação de aprovação é atualizada",
      approvalAutomationIsNotUpdated: "Automação de aprovação não está atualizada",
      collectionAutomationRegistered: "Automação de cobrança registrada",
      collectionAutomationNotRegistered: "Automação de cobrança não cadastrada",
      approvalAutomationIsRegistered: "A Automação de Aprovação é Registrada",
      approvalAutomationIsNotRegistered: "Automação de aprovação não está registrada",
      strawAutomationUpdated: "Automação de palha atualizada",
      strawAutomationIsNotUpdated: "Straw Automation não está atualizado",
      searchSire: "Procurar senhor",
      strawsEdit: "Canudos Editar",
      nextAnimals: "próximo animal",
      performanceInfo: {
        milk: "Leite",
        liveweight: "peso vivo",
        score: "Pontuação",
        fertility: "Fertilidade",
        measurements: "Medidas",
        dailyProteinYield: "Rendimento Diário de Proteína",
        amountProteinMilkCowDay: "Quantidade de proteína no leite obtida de uma vaca em determinado dia.",
        dailyMilkYield: "Produção diária de leite",
        volumeMilkCowDay: "Volume de leite obtido de uma determinada vaca em um determinado dia.",
        dailyFatYield: "Rendimento diário de gordura",
        amountFatMilkCowDay: "Quantidade de gordura no leite obtido de uma vaca no dia específico.",
        dailyProteinContent: "Conteúdo diário de proteína",
        dailyFatContent: "teor diário de gordura",
        milkLactose: "Leite Lactose",
        amountLactoseMilk: "Quantidade de lactose no leite.",
        milkUrea: "Leite Uréia",
        indicatorAmountCrudeProtein: "Indicador da quantidade de proteína bruta na dieta de uma vaca",
        lactationNumber: "número de lactação",
        ordinalNumLactation: "O número ordinal da lactação.",
        lengthOfLactation: "Duração da lactação (por exemplo, 23 dias)",
        lactationLength: "Duração da lactação",
        milkingFrequency: "Frequência de ordenha",
        frequcnyOfMilking: "Frequência de ordenha (por exemplo, 2 vezes/dia)",
        liveWeightInformation: "Informações de peso vivo",
        currentWeight: "Peso atual",
        weightAnimal: "Peso do animal.",
        postWeaningGain: "Ganho pós-desmame",
        dailyGainInAnimalWeightWeaning: "Ganho diário de peso do animal após o desmame.",
        weaningWeight: "peso ao desmame",
        weightAnimalMeasuredWeaning: "Peso do animal medido em um dia de desmame.",
        averageDailyGain: "Ganho médio diário",
        averageAmountWeightAnimalGainFeedingPeriod: "A quantidade média de peso que um animal ganhará a cada dia durante o período de alimentação",
        carcassWeight: "Peso da carcaça",
        weightAnimalsHideInternalOrgansRemoved: "Peso dos animais após a remoção da cabeça, couro e órgãos internos.",
        weightAtCalving: "Peso ao parto",
        weightAtTheTimeOfCalving: "Peso no momento do parto.",
        yearlingWeight: "Peso de um ano",
        weightYearOldAnimal: "Peso de um animal de um ano.",
        somaticCellScore: "Pontuação de células somáticas",
        somaticCellScoreIndicatorMastitis: "Escore de células somáticas como indicador de mastite. ",
        lastUpdate: "Última atualização",
        bodyConditionScore: "Pontuação da condição corporal",
        scoreAnimalFat: "Uma pontuação de animal em relação a quantas gorduras ele tem.  ",
        teatScore: "Pontuação do teto",
        scoreMeasureingShapeTeats: "As pontuações do tamanho do teto são avaliações subjetivas do comprimento e circunferência do teto e variam de 9 (muito pequeno) a 1 (muito grande). ",
        udderScore: "Pontuação de suspensão do úbere",
        scoreMeasureingShapeOfUdder: "Pontuação medindo a forma do úbere (pontuação 1-9). ",
        whetherAnimalEasyBirthDifficult: "O nascimento no gado é um processo natural, mas às vezes pode haver problemas de nascimento onde a barragem precisa de ajuda do fazendeiro/pastor.",
        totalLongevity: "longevidade total",
        survivalLactationTraitCowCulledBreeding: "Sobrevivência da 1ª à 5ª lactação. ",
        docility: "Docilidade",
        circumferenceBullScrotal: "Circunferência do escroto do touro",
        intervalSuccessInsemination: "Intervalo desde a primeira até a inseminação bem-sucedida.",
        ageAtFirstCalving: "Idade ao primeiro parto",
        ageCowCalving: "Qual a idade da vaca no primeiro parto.",
        calvingInterval: "Intervalo de parto",
        periodCalving: "O período de um parto ao próximo parto.",
        scrotalCircumference: "Circunferência Escrotal",
        estrusDetection: "Detecção de Estro",
        trackingBehaviorAnimalDetectingEstrus: "Rastreamento do comportamento do movimento do animal para detectar o estro de uma vaca.",
        presenceOfEstrus: "Presença de Estro",
        isCowInEstrusStage: "É quando uma vaca está no estágio de estro ou não",
        matureWeight: "Peso maduro",
        weightAnimalDefinedAge: "Peso de um animal em uma idade definida.",
        matureHeight: "Altura adulta",
        heightAnimalDefinedAge: "Altura de um animal em idade definida.",
        footClawSet: "conjunto de garras de pé",
        shapeAnimalClaw: "Forma de garra de animal.",
        pulmonaryArterialPressure: "Pressão Arterial Pulmonar",
        animalBloodPreasure: "Pressão sanguínea do animal.",
        footAngle: "Ângulo do pé",
        shapeAnimalFoot: "Forma do pé do animal.",
        ribEyeArea: "Área de olho de lombo",
        amountRibEyeArea: "Quantidade de área de olho de lombo.",
        ultrasoundFat: "gordura de ultrassom",
        measureFatAmount: "Medida da quantidade de gordura.",
        ultrasoundIntramuscularFat: "Gordura Intramuscular Ultrassom",
        ultrasoundRibEyeArea: "Área do olho da costela de ultrassom",
        measureRibeyeArea: "Medida da área de olho de lombo.",
        fatThickness: "Espessura de gordura",
        anmountAnimalBackFat: "Quantidade de gordura dorsal do animal.",
        marbling: "marmorização",
        marballingMeasurement: "O marmoreio é a gordura intramuscular insaturada visível (saudável) que se acumula dentro do músculo e entre os feixes de fibras musculares.",
        dryMatterIntake: "Ingestão de matéria seca",
        amountFeedAnimalConsumesAMoisture: "Quantidade de ração que um animal consome por dia, sem umidade."
      },
      feedsName: "Nome dos feeds",
      feedName: "Nome do feed",
      firstFeedQuantity: "Primeira quantidade de alimentação",
      additionalFeed: "Alimentação Adicional",
      cloversRyeGrasses: "Trevos, gramíneas de centeio",
      greenFodderHayLegumes: "Forragem Verde, Feno, Leguminosas",
      feedsRegisteredSuccessfully: "Feeds registrados com sucesso",
      feedsNotRegistered: "Feeds Não Registrados",
      fEEDQUANTITY: "QUANTIDADE DE ALIMENTAÇÃO",
      feedQuantity: "Quantidade de alimentação",
      fEEDNAME: "NOME DA ALIMENTAÇÃO",
      nOFEEDINFOAVAILABLE: "NENHUMA INFORMAÇÃO DE FEED DISPONÍVEL",
      searchByFeedName: "Pesquise pelo nome do feed",
      loadingFeedInfo: "Carregando informações do feed... Aguarde",
      todayFeedInfo: "Informações do feed de hoje",
      feedInfo: "Informações de alimentação",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "Se este valor genético é usado para o cálculo do índice econômico.",
        dailyProteinYieldUsed: "Rendimento Diário de Proteína Usado",
        weightAssignedBreedingDailyProteinYield: "Peso atribuído ao valor genético correspondente ao \"Rendimento diário de proteína\"." ,
        dailyProteinYieldWeight: "Peso de Rendimento Diário de Proteína",
        rankAnimalInRelationshipEconomicIndex: "Classificação do animal em relação ao índice econômico.",
        economicIndexRank: "Classificação do índice econômico",
        percentileEconomicIndexFall: "Percentil em que o índice econômico se enquadra.",
        economicIndexPercentile: "Percentil do índice econômico",
        accuracyOfEconomicIndex: "Precisão do índice econômico.",
        economicIndexAccuracy: "Precisão do índice econômico",
        weightedAverageOfBreedingValues: "Média ponderada dos valores genéticos.",
        economicIndex: "Índice Econômico",
        rankOfAnimalInRelationshipBreeding: "Classificação do animal em relação ao valor genético correspondente.",
        dailyProteinYieldBreedingValueRank: "Classificação diária de valor de criação de rendimento de proteína ",
        percentileBreedingFalls: "Percentil em que o valor genético se enquadra.",
        dailyProteinYieldBreedingPercentile: "Percentil de valor de criação de rendimento diário de proteína ",
        accuracyEstimatedBreeding: "Precisão do valor genético estimado.",
        dailyProteinYieldBreedingAccuracy: "Precisão do valor de criação de rendimento diário de proteína",
        estimatedBreedingTraitDailyProteinYield: "Valor genético estimado da característica \"Rendimento diário de proteína.",
        dailyProteinYieldBreedingValue: "Rendimento Diário de Proteína Valor de Melhoramento ",
        pathToTheDirectoryScriptsBreeding: "Caminho para o diretório no disco rígido contendo os scripts que foram usados ​​para o cálculo do valor de reprodução.",
        scriptsPath: "Caminho dos scripts",
        softwarePackageBreeding: "Pacote de software que foi usado para calcular o valor genético.",
        breedingValueSoftware: "Software de valor de criação",
        methodCalculateBreeding: "O método que foi usado para calcular a reprodução",
        breedingValueMethod: "Método de valor de reprodução",
        trait: "Característica",
        tools: "Ferramentas",
        geneticWorth: "valor genético",
        dailyProteinYield: "Rendimento Diário de Proteína",
        breedingValue: "Valor de reprodução",
        breedingValueBIFAccuracy: "Precisão BIF de valor de reprodução",
        breedingValuePercentile: "Percentil de valor de reprodução",
        breedingValueRank: "Classificação de valor de reprodução",
        checkLTD: "Cheque LTDA",
        ultrasoundDiagnostic: "Diagnóstico de ultrassom",
        selectYieldUsed: "Selecione o rendimento usado",
        softwareName: "Nome do software",
        animalGenWorthUpdatedSuccessfully: "Animal Gen Worth atualizado com sucesso"
      },
      addNote: "Adicionar nota",
      enterNote: "Inserir nota",
      noteIsRequired: "Nota é necessária",
      noteMustBeLessThan50Characters: "A nota deve ter menos de 50 caracteres",
      noteAdded: "Nota adicionada",
      noteNotAdded: "Nota não adicionada",
      noteForAnimal: "Nota para animais.",
      noNoteFoundForThisAnimal: "Nenhuma nota encontrada para este animal.",
      inseminationData: "Dados de inseminação",
      nameOfInseminator: "Nome do inseminador",
      activity: "Atividade",
      searchByNameActivity: "Pesquise por nome, atividade",
      searchByTaskNameNumber: "Pesquise por nome de tarefa, número",
      inseminationDate: "Data de Inseminação",
      genotypeDataInfo: {
        genotypeAnimalID: "Genótipo Animal ID",
        iDTubeBloodSampleAnimalNumberGenotypingService: "Esta é a identificação de um tubo com uma amostra de sangue retirada do animal ou de um número de serviço de genotipagem",
        geneticTechnicianName: "Nome do Técnico Genético",
        NameTechnicianBloodSamplesAnimal: "Este é o nome de um técnico que tirou amostras de sangue do animal",
        sNPData: "dados SNP",
        genotypingServiceNote: "Nota do Serviço de Genotipagem",
        InfoGenotypingGenotypingTechnology: "Todas as informações relacionadas à genotipagem, como nome da empresa de genotipagem, tecnologia de genotipagem utilizada, data da genotipagem, etc.",
        numberOfSNPs: "Número de SNPs",
        numberOfSNPsAnimalGenotyped: "Número de SNPs para os quais o animal foi genotipado",
        nameOfTheDrug: "Nome da Droga",
        animalGenoDataUpdatedSuccessfully: "Dados genéticos de animais atualizados com sucesso",
        animalGenoDataNotUpdated: "Dados genéticos animais não atualizados",
        animalIDIsRequired: "A identificação do animal é obrigatória",
        techNameIsRequired: "Tecnologia ",
        onlyAlphabetsAreAllowed: "Somente alfabetos são permitidos",
        genoDataIsRequired: "Os dados Geno são obrigatórios",
        serviceNoteIsRequired: "Nota de serviço é necessária",
        sNPIsRequired: "SNP é obrigatório"
      },
      healthRecordInfo: {
        treatment: "Tratamento",
        treatmentTakenAnimal: "Que tratamento foi feito no animal.",
        reasonOfTreatment: "Motivo do Tratamento",
        reasonForTreatment: "Motivo do Tratamento",
        whatReasonOfTreatment: "Qual é o motivo do tratamento.",
        treatmentDate: "Data do tratamento",
        dateOfTreatment: "Data do tratamento.",
        diagnosis: "Diagnóstico",
        nameDiagnosedDiseaseConditionSymptoms: "Nome da doença/condição diagnosticada ou sintomas principais",
        drugID: "Identificação do medicamento",
        iDOfDrugWhichIsGivenToAnimal: "ID da droga que é dada ao animal.",
        drugName: "Nome do medicamento",
        nameDrugAnimal: "Nome da droga administrada ao animal.",
        drugWithdrawalPeriod: "Período de Retirada do Medicamento",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "O tempo necessário após a administração de um medicamento a um animal para garantir a segurança da carne ou do leite para consumo humano",
        attendingVeterinarian: "Veterinário assistente",
        qualifiedPersonCaseAnimal: "A pessoa qualificada que viu o caso/animal",
        packID: "ID do pacote",
        iDPackTreatment: "ID de um pacote que foi usado para tratamento",
        veterinarianName: "Nome do Veterinário",
        animalNoHealthRecord: "Este animal não tem qualquer Registo de Saúde. ",
        addHealthRecord: "Adicionar registro de saúde",
        healthStatus: "Estado de saúde",
        loadingDiseasesPleaseWait: "Carregando Doenças... Por favor, aguarde",
        animalDiseaseRecord: "Registro de Doença Animal",
        animalHealthRecord: "Registro de Saúde Animal",
        animalTreatmentRecord: "Registro de Tratamento Animal",
        loadingHealthData: "Carregando dados de saúde...",
        healthRecord: "Histórico de saúde",
        nameOfDiagnosis: "Nome do diagnóstico",
        treatmentName: "Nome do tratamento",
        drugGivenBy: "Droga dada por",
        recessiveDiseases: "Doenças Recessivas",
        recessiveDiseasesMessage: "Quais alelos de doença recessiva este touro é portador de"
      },
      conceptionInfo: {
        addNewConception: "Adicionar nova concepção",
        semenEmbryo: "Sêmen/Embrião",
        pregnancyCheck: "Verificação de gravidez",
        birthInfo: "Informações de Nascimento",
        searchByInseminatorOrganisationBreedingConception: "Pesquise por nome do inseminador, nome da organização, número do serviço de reprodução, método de concepção",
        deliveryDate: "Data de entrega",
        calfId: "Identificação do bezerro",
        birthDayOldWeight: "Peso de nascimento (dia de vida)",
        searchByBirthEase: "Pesquisar por facilidade de nascimento",
        searchPregnancyCheckOperatorMethod: "Pesquise por operador de verificação de gravidez, método de verificação de gravidez",
        pregnancyCheckDate: "Data de Verificação de Gravidez",
        conceptionSuccess: "sucesso da concepção",
        pregnancyCheckOperator: "Operadora de cheques de gravidez",
        pregnancyCheckMethod: "Método de Verificação de Gravidez",
        recentlyPregnant: "Grávida Recentemente",
        pregnancyConfirmationDate: "Data de Confirmação da Gravidez",
        pregnancyRate: "taxa de gravidez",
        timePeriodOfPregnancy: "Período de tempo da gravidez",
        semenProduction: "Produção de sêmen",
        embryoProduction: "Produção de embriões",
        semen: "sêmen",
        embryoTransferDate: "Data de transferência do embrião",
        daysOfPregnancy: "Dias de Gravidez",
        searchSireEmbryoSurrogate: "Pesquise por ID do pai, nome da organização do embrião, raça da mãe substituta",
        selectDate: "Selecione a data",
        orgnisationNameContainNumber: "O nome da organização não deve conter o número",
        selectBirthEase: "Selecione facilidade de nascimento",
        selectUnit: "Selecione uma unidade",
        animalConceptionAddedSuccessfully: "Concepção de animais adicionada com sucesso",
        postageCustomerName: "Nome do cliente postal",
        searchByPostageCustNameCustAddPostId: "Pesquise por nome do cliente de postagem, endereço do cliente, ID da postagem",
        dateOfSemenCollection: "Data da Coleta de Sêmen",
        dateOfSemenPreparation: "Data de preparação do sêmen",
        semenMotility: "Motilidade do sêmen",
        semenConcentration: "Concentração de Sêmen",
        postageEdit: "Postagem Editar",
        enterSireId: "Digite o ID do pai",
        selectEmbryoOrganisation: "Selecione a organização do embrião",
        matingDateH: "Data da concepção, acasalamento natural ou inseminação artificial.",
        inseminatorNameH: "Pessoa que realiza o processo de inseminação (veterinário/técnico)",
        orgNameH: "Nome da organização ou empresa que fornece a palheta de sêmen para IA",
        brServiceNumH: "Registrando o número de reprodutores (por exemplo, 1º, 2º ou 3º)",
        conceptionMethodH: "A forma como o animal concebeu é o início da gravidez, marcada pela fecundação de um óvulo por um espermatozoide.",
        sireIdH: "O ID do pai/mãe masculino do animal",
        damIdH: "O ID do progenitor/mãe do animal.",
        sarogatedDamH: "O ID da vaca fêmea na qual o óvulo fertilizado de um macho doador e de uma fêmea doadora é implantado para seu desenvolvimento posterior.",
        embOrgNameH: "O nome da organização para o embrião",
        sarogateDamBreedH: "A data da raça substituta",
        sireBreedH: "O tipo da raça do pai (brahman, boran)",
        pregCheckDateH: "A prenhez pode ser detectada em vacas a partir dos 30 dias usando ultrassom e exames de sangue. Para que as vacas sejam identificadas como prenhes usando o método de palpação, elas geralmente precisam estar com pelo menos 35 a 50 dias de gestação. ",
        conceptionSuccessH: " Em bovinos, a taxa de fertilização é de 90% com uma taxa média de parição de cerca de 55%, indicando uma mortalidade embriofetal de cerca de 35% (Diskin et al., 2006). ",
        pregnancyCheckOperatorH: "Os veterinários e técnicos especializados em animais geralmente fornecem esses serviços aos agricultores. ",
        pregnancyCheckMethodH: "Os dois métodos mais usados ​​para o diagnóstico de gestação em bovinos são a palpação manual do trato reprodutivo (por reto) e a ultrassonografia transretal do trato reprodutivo",
        deliveryDateH: "Data em que o parto aconteceu",
        calfIdH: "ID do bezerro recém-nascido",
        birthEaseH: "O nascimento no gado é um processo natural, mas às vezes pode haver problemas de nascimento onde a barragem precisa de ajuda do fazendeiro/pastor.",
        birthDayOldWeightH: "Peso de um animal no dia do nascimento ou peso de uma ave de um dia",
        customerAddress: "Endereço do cliente"
      },
      all: "Todos",
      ungrouped: "Animais não agrupados",
      active: "Animais Agrupados",
      updateAnimal: "atualizar animal"
    },
    dashboardS: {
      dailyActivities: "Atividades diárias",
      pendingTasks: "Tarefas Pendentes",
      performanceOfGeno: "Desempenho de Genótipos",
      breed: "Raça",
      chromosome: "Cromossoma",
      seqChange: "Mudança de sequência",
      inheritance: "Herança",
      diseaseName: "Nome da doença",
      refSequence: "Sequência de Referência",
      pubmedRef: "Referência Pubmed",
      matingDate: "Data de acasalamento",
      inseminatorName: "Nome do Inseminador",
      orgName: "Nome da organização",
      brServiceNum: "Número do Serviço de Reprodução",
      conceptionMethod: "Método de concepção",
      semEmbInfo: "Informações de sêmen/embrião",
      sireId: "ID do pai",
      damID: "ID da barragem",
      srgDamId: "ID da barragem substituta",
      embOrgName: "Embrião Org. ",
      srgDamBreed: "Raça Substituta",
      sireBreed: "Raça de pai",
      damBreed: "Barragem"
    },
    user: {
      selectLanguage: "Selecione o idioma",
      unitPreference: "Preferência de unidade",
      selectUnitOfMeasure: "Selecione a unidade de medida",
      importedUser: "Usuário importado",
      impFileStatus: "Status do Arquivo de Importação",
      loadingUser: "Carregando usuários... Por favor, aguarde",
      totalUsers: "Total de usuários",
      pendingUsers: "Usuários Pendentes",
      changePassword: "Alterar a senha",
      goodIdeaToUsePassword: "É uma boa ideia usar uma senha forte que você não esteja usando em outro lugar.",
      enterCurrentPassword: "Insira a senha atual",
      enterNewPassword: "Insira a nova senha",
      reEnterPassword: "Re-introduza a nova palavra-passe",
      enterPassword: "Digite a senha",
      repeatNewPassword: "Repita a nova senha",
      emailAddr: "Endereço de email",
      enterYourPhoneNumber: "Digite seu número de telefone",
      pleaseTypeOldPassword: "Digite a senha antiga.",
      pleaseTypeNewPassword: "Por favor, digite a nova senha.",
      pleaseTypeConfirmPassword: "Por favor digite confirme a senha.",
      passwordChangedSuccesFully: "Senha alterada com sucesso",
      currentPassword: "Senha atual",
      newPassword: "Nova Senha",
      passwordDoesNotMatch: "As senhas não correspondem.",
      emailCanNotBeEmpty: "O e-mail não pode estar vazio",
      profileUpdated: "Perfil atualizado",
      profileNotUpdated: "Perfil não atualizado",
      unableToVerifyEmail: "Não foi possível verificar o e-mail",
      otpSentOnEmail: "OTP enviado por e-mail",
      otpSentSuccessFully: "OTP enviado com sucesso",
      importUsers: "Importar usuários",
      imageUpdated: "Imagem atualizada",
      departmentName: "Nome do departamento",
      departmentNum: "Número do Departamento",
      departmentAdded: "Departamento adicionado",
      departmentNotAdded: "Departamento não adicionado",
      searchDepartnment: "Pesquise por nome ou número do departamento",
      addDepartMent: "Adicionar Departamento",
      addDepartment: "Adicionar departamento",
      roleNameIsRequired: "O nome da função é obrigatório",
      roleNameMustBeLessThan15Chars: "O nome da função deve ter menos de 15 caracteres",
      roleAdded: "Função adicionada",
      editDepartment: "Editar departamento",
      departmentUpdated: "Departamento atualizado",
      departmentNotUpdated: "Departamento não atualizado",
      deleteDepartment: "Excluir departamento",
      deleteDepartmentMessage: "Tem certeza de que deseja excluir este departamento.",
      noRoleAvailable: "NENHUM PAPEL DISPONÍVEL",
      roleUpdated: "Função atualizada",
      roleNotUpdated: "Função não atualizada",
      editRole: "Editar Função",
      allRole: "Todas as funções",
      addNewRole: "Adicionar nova função",
      allDepartment: "Todos os departamentos",
      permissionsUpdated: "Permissões atualizadas",
      permissionsnotUpdated: "Permissões não atualizadas",
      roleNo: "Número da função",
      searchByEmailAndName: "Pesquise por e-mail e nome",
      userID: "ID do usuário",
      userUpdated: "Usuário atualizado",
      userNotUpdated: "Usuário não atualizado",
      userAdded: "Usuário adicionado",
      userNotAdded: "Usuário não adicionado",
      activateUser: "Ativar usuário",
      deactivateUser: "Desativar usuário",
      userStatusMsg: "Tem certeza de que deseja alterar o status do usuário",
      countryRequired: "O país é obrigatório",
      stateRequired: "O estado é obrigatório",
      cityRequired: "A cidade é obrigatória",
      searchByRole: "Pesquise por número da função, nome da função, departamento",
      noModuleAvailable: "Nenhum módulo disponível",
      searchBYModuleName: "Pesquisar por nome do módulo"
    },
    farm: {
      farmID: "ID da fazenda",
      onTheFarm: "Na fazenda",
      userRoles: "Funções do usuário",
      adduser: "Adicionar usuário",
      addAuser: "Adicionar um usuário",
      uploadUsers: "Carregar usuários",
      addNewUser: "Adicionar novo usuário",
      selectDept: "Selecione o Departamento",
      selectRole: "Selecione a Função",
      editUser: "Editar usuário",
      totalFarms: "Fazendas totais",
      NoAnimalsRegisteredForthisFarm: "Nenhum animal está registrado para esta fazenda",
      farmsPerPage: "Fazendas por página",
      regularFarms: "Fazendas Regulares",
      farmRegisteredProducts: "Produtos Agrícolas Registrados",
      searchByFarmNameAndId: "Pesquise por nome e id da fazenda",
      loadingProductsPleaseWait: "Carregando produtos... Por favor, aguarde",
      farmName: "Nome da Fazenda",
      farmLocation: "Localização da fazenda",
      productName: "Nome do Produto",
      stockStatus: "Status do Estoque",
      inStock: "Em estoque",
      searchByProductName: "Pesquisar por nome do produto",
      productCategory: "Categoria de Produto",
      products: "Produtos",
      farms: "Fazendas",
      registerAfarm: "Registrar uma Fazenda",
      govtRegistry: "Governo ",
      cooperativeID: "ID da cooperativa",
      farmType: "Tipo de fazenda",
      contractMating: "Contrato de Acasalamento",
      customization: "Costumização",
      recordsPerpage: "Registros por página",
      restoreDefault: "Restaurar padrão",
      apply: "Aplicar",
      searchState: "Pesquise por ID da Fazenda, Registro Governamental, ID da Cooperativa, Tipo de Fazenda, Contrato de Acasalamento",
      farmOwner: "Proprietário da Fazenda",
      govRegistrationNo: "Número de registro do governo",
      farmInformation: "Informação da Fazenda",
      ownershipType: "Tipo de propriedade",
      communityName: "Nome da comunidade",
      farmLicenseInformation: "Informação de licença agrícola",
      licenseNumber: "Número de licença",
      licenseExpiryDate: "Data de expiração da licença",
      regulatorName: "Nome do regulador",
      regulatorRepresentativeName: "Nome do representante do regulador",
      farmLocationSize: "Localização da fazenda",
      productionSystem: "Sistema de produção",
      country: "País",
      state: "Estado",
      city: "Cidade",
      street: "Rua",
      houseNumber: "Número da casa",
      farmRegistration: "Cadastro de Fazenda",
      cancel: "Cancelar",
      register: "Registro",
      ok: "OK",
      totalFarmSize: "Tamanho Total da Fazenda",
      farmGeographicLocation: "Localização Geográfica da Fazenda",
      perimeterPointLongitude: "Longitude do Ponto do Perímetro",
      perimeterPointLatitude: "Latitude do ponto do perímetro",
      perimeterPointLabel: "Rótulo de ponto de perímetro",
      perimeterLength: "Comprimento do perímetro",
      farmLatitude: "Fazenda Latitude",
      farmLongitude: "Fazenda Longitude",
      editFarm: "Editar Fazenda",
      update: "Atualizar",
      editAfarm: "Editar uma fazenda",
      nextFarm: "Próxima Fazenda",
      nameoftheFarm: "Nome da Fazenda",
      registerAProduct: " Registrar um produto",
      farmProducts: "Produtos Agrícolas",
      calf: "Panturrilha",
      steer: "Dirigir",
      heifer: "Novilha",
      sire: "Pai",
      dam: "Barragem",
      registerAnAnimal: "Registrar um animal",
      farmAnimals: "Animais de fazenda",
      farm_type: "tipo fazenda",
      farm_Owner: "Dono da Fazenda",
      dateOfRegistration: "Data de registro",
      dataIsNotAvailableForThisFarm: "Os dados não estão disponíveis para esta fazenda",
      registerNewProduct: "Registrar um novo produto",
      information: "Informação",
      licenseInfo: "Informações da licença",
      locationInfo: "Informações de localização",
      geoLocation: "Localização geográfica",
      perimeterLengthState: "Comprimento do Perímetro das Fazendas (comprimento da cerca)",
      totalFarmSizeState: "Tamanho de uma Fazenda",
      productionSystemState: "Sistema de Produção Utilizado na Fazenda",
      contractMatingState: "Código do Programa de Cobrição por Contrato do qual a Fazenda Participa.",
      ownershipTypeState: "Tipo de propriedade",
      regulatorRepresentativeNameState: "Nome da pessoa que representa o regulador que liberou a licença",
      regulatorNameState: "Nome do regulador que liberou a licença",
      licenseExpiryDateState: "Data em que a licença atual expirou",
      licenseNumberState: "Número da licença divulgado pelo regulador",
      plotNumberState: "Número da casa da fazenda.",
      plotNumber: "Número da casa/lote",
      streetStatement: "Nome da rua da fazenda.",
      cityStatement: "Cidade onde está localizada a fazenda.",
      stateStatement: "Região do país onde a fazenda está localizada.",
      countryState: "País onde a fazenda está localizada.",
      perimeterPointLongitudeState: "Longitude de um ponto na fazenda.",
      perimeterPointLatitudeState: "Latitude de um ponto na fazenda.",
      perimeterPointLabelState: "Rótulo de Ponto.",
      farmLongitudeState: "Longitude da fazenda.",
      farmLatitudeState: "Latitude da fazenda.",
      farmNameH: "Nome da fazenda",
      farmTypeH: "O tipo de fazenda onde diferentes atividades são realizadas.",
      farmOwnerH: "Nome do proprietário de uma fazenda (nome do fazendeiro gerado automaticamente, inserindo informações)",
      ownershipTypeH: "O tipo de agricultores que possuem/controlam as terras que cultivam e os que não as possuem.",
      govtRegNumbH: "Número de registro da fazenda que foi atribuído pelo regulador",
      contractMatingH: "Código do programa de acasalamento por contrato do qual a fazenda participa",
      productionSystemH: "Qual o sistema de produção utilizado na fazenda",
      cooperativeIDH: "ID de uma cooperativa da qual a fazenda é membro ",
      licenseNumberH: "Número de identificação em uma licença emitida pelo regulador que o identifica com o proprietário.",
      licenseExpiryDateH: "Data em que a licença atual expirou",
      regularNameH: "Nome do regulador que liberou a licença",
      regularRepName: "Nome da pessoa que representa o regulador que liberou a licença",
      countryH: "País onde a fazenda está localizada.",
      stateH: "Região do país onde a fazenda está localizada.",
      cityH: "Cidade onde está localizada a fazenda.",
      streetH: "Nome da rua da fazenda.",
      houseNumberH: "Número da casa da fazenda.",
      totalFarmSizeH: "O tamanho da fazenda é a soma da terra atualmente cultivada pela fazenda, incluindo a terra em pousio, mas excluindo a terra com vegetação natural, árvores ou pastagens.",
      farmLatitudeH: "É a medida da distância ao norte ou ao sul do Equador. ",
      farmLongitudeH: "Ele mede a distância a leste ou a oeste do meridiano principal.",
      perimeterLengthH: "Comprimento do perímetro das fazendas (comprimento da cerca)",
      perimeterPointLabelH: "Etiqueta do ponto. ",
      perimeterPointLatH: "Latitude de um ponto na fazenda",
      perimeterPointLongH: "Longitude de um ponto na fazenda",
      noProductAvailable: "Nenhum produto disponível",
      farmUpdated: "Fazenda Atualizada",
      performance: "Desempenho",
      milkInformation: "Informação do Leite",
      farmNameRequired: "O nome da Fazenda é obrigatório"
    },
    login: {
      welcome: "Bem-vindo! ",
      welInfo: "Digite suas credenciais.",
      login: "Conecte-se",
      forgotPassword: "Esqueceu sua senha",
      forgotPasswordDesc: "Por favor insira o endereço de email associado à sua conta. ",
      backToLogin: "Volte ao login"
    },
    actionListmod: {
      actionList: "Lista de Ação",
      tODAY: "Hoje",
      createTask: "Criar tarefa",
      myActivities: "Minhas atividades",
      jhonSmith: "Jhon Smith",
      farmID: "ID da fazenda",
      dateOfEvent: "Data do evento",
      actionRequired: "Ação requerida",
      actionTaken: "Medida tomada",
      animalEventID: "Identificação do evento do animal",
      cANCEL: "Cancelar",
      cONFIRM: "confirme",
      sTATEMENT: "Tem certeza de que deseja excluir este registro?",
      dAY: "Dia",
      wEEK: "Semana",
      mONTH: "Mês",
      sUBMIT: "Enviar",
      startDate: "Data de início",
      endDate: "Data final",
      rEPEAT: "Repita",
      taskCategory: "Categoria de tarefa",
      pRIORITY: "Prioridade",
      aSSIGNEE: "Cessionário",
      selectLocation: "Selecione o local",
      selectAnimals: "Selecione um ou mais animais",
      dESCRIPTION: "Descrição",
      customRecurrence: "Recorrência personalizada",
      repeatEvery: "Repetir a cada",
      taskName: "Nome da tarefa",
      enterDescription: "Insira a descrição",
      toDo: "Pendência",
      assignTo: "Atribuir a",
      status: "Status",
      nOTE: "Observação",
      noTaskAvailable: "NENHUMA TAREFA DISPONÍVEL",
      healthRecord: "Histórico de saúde",
      iD: "EU IA",
      tAG: "Marcação",
      dateOfbirth: "Data de nascimento",
      taskTakenat: "Tarefa realizada em",
      gENDER: "Gênero",
      bREED: "Raça",
      regDate: "Reg. ",
      updateHealthRecord: "Atualizar registro de saúde para animais",
      treatment: "Tratamento",
      reasonOftreatment: "Motivo do tratamento",
      treatmentDate: "Data do tratamento",
      dIAGNOSIS: "Diagnóstico",
      drugId: "Identificação do medicamento",
      drugName: "Nome do medicamento",
      drugWithdrawalperiod: "Período de Retirada do Medicamento",
      attendingVeterinarian: "Veterinário assistente",
      packId: "ID do pacote",
      noItemsselected: "Nenhum item selecionado",
      healthRecordsubmission: "Envio de registro de saúde",
      inseminationRecordsubmission: "Envio de registro de inseminação",
      inseminatorName: "Nome do inseminador",
      inseminatorId: "ID do inseminador",
      conceptionRate: "Taxa de concepção",
      dateOfmeasurement: "Data de Medição",
      recordSubmission: "Envio de registro",
      uPDATE: "Atualizar",
      updateTask: "Tarefa de atualização"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "Adicionar informações do inseminador",
      inseminatorNumber: "Número do Inseminador",
      loadingInseminatorPleaseWait: "Carregando Inseminador... Por favor, aguarde",
      searchByIDAndName: "Pesquise por ID e nome",
      inseminatorInfoAdded: "Informações do inseminador adicionadas",
      inseminatorInfoNotAdded: "Informações do inseminador não adicionadas",
      inseminatorInfoUpdated: "Informações do inseminador atualizadas",
      inseminatorInfoNotUpdated: "Informações do inseminador não atualizadas",
      editAInseminatorInfo: "Editar informações do inseminador",
      inseminatorList: "Lista de inseminadores",
      inseminatorInfoDetails: "Detalhes de informações do inseminador",
      updateInseminatorInfo: "Atualizar informações do inseminador"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "Carregando Pedidos... Aguarde",
      addStocks: "Adicionar ações",
      addStock: "Adicionar Estoque",
      quantity: "Quantidade",
      selectUnit: "Selecionar unidade",
      farmProducts: "Produtos Agrícolas",
      cost: "Custo",
      transactionID: "ID da transação",
      recipientID: "ID do destinatário",
      orderID: "ID do pedido",
      recepientName: "Nome do destinatário",
      createAOrder: "Criar um pedido",
      totalStocks: "Total de Estoques",
      orders: "Pedidos",
      totalPending: "Total Pendente",
      totalDelivered: "Total Entregue",
      searchByRecepientNameOrderIdRecepientId: "Pesquise por nome do destinatário, ID do pedido, ID do destinatário",
      chooseTheDate: "Escolha a data",
      transactionDate: "Data da Transação",
      selectCategory: "Selecione a Categoria",
      volumeOfProduct: "Volume de produto",
      productQuantity: "Quantidade de produto",
      productRecipientId: "ID do destinatário do produto",
      productRecipientName: "Nome do destinatário do produto",
      productRecipientType: "Tipo de Destinatário do Produto",
      singleProduct: "Produto único",
      orderPlaced: "Pedido feito",
      orderNotPlaced: "Pedido não feito",
      totalPrice: "Preço total",
      currency: "Moeda",
      selectCurrency: "Escolha a moeda",
      address: "Endereço",
      enterAddress: "Insira o endereço",
      attachments: "Anexos",
      chooseFile: "Escolher arquivo",
      nameOfTheFarm: "Nome da fazenda",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Lorem Ipsum tem sido o texto fictício padrão da indústria desde os anos 1500, quando uma impressora desconhecida pegou um",
      billedTo: "Faturado para",
      orderStatus: "Status do pedido",
      selectStatus: "Selecione o estado",
      cadbury: "Cadbury",
      totalAmount: "Montante total",
      deliveryCharges: "Taxas de entrega",
      orderDetails: "detalhes do pedido",
      deliveryOnTime: "Entrega no prazo",
      productID: "ID do produto",
      productRegistration: "Registo de produto",
      enterTheNameOfTheProduct: "Digite o nome do produto",
      nameOfTheProduct: "Nome do produto",
      productAdded: "Produto adicionado",
      productNotAdded: "Produto não adicionado"
    },
    drug: {
      dRUGS: "Drogas",
      registerAdrug: "Registrar um medicamento",
      sEARCH: "Procurar",
      genericName: "Nome genérico",
      manufacturer: "Fabricante",
      distributor: "Distribuidor",
      registrationDate: "data de registro",
      drugRegistration: "Registro de medicamentos",
      drugInformation: "Informações sobre medicamentos",
      packExpiration: "Expiração do pacote",
      drugId: "Identificação do medicamento",
      drugName: "Nome do medicamento",
      drugGenericname: "Nome Genérico do Medicamento",
      drugManufacturer: "Fabricante de medicamentos",
      distributorName: "Nome do Distribuidor",
      drugRegistrationdate: "Data de Registro do Medicamento",
      nextDrug: "Próxima droga",
      editDrug: "Editar droga",
      updateDrug: "Atualizar Medicamento",
      deleteDrug: "Excluir droga",
      noRecordfound: "Nenhum Registro Encontrado",
      addDrug: "Adicionar droga",
      statementDrug: "A droga foi deletada.  ",
      cANCEL: "Cancelar",
      cONFIRM: "confirme",
      sTATEMENT: "Tem certeza de que deseja excluir este registro?",
      ok: " OK",
      information: "Informação",
      packOrder: "Pedido de embalagem",
      packPrescription: "Prescrição de pacote",
      packReservation: "Reserva de pacote",
      packLocation: "Localização do Pacote",
      drugDozedam: "Dose de droga em um dia para barragem",
      drugDozecalf: "Dose de medicamento em um dia para bezerros",
      drugFormate: "Formato de medicamento",
      drugDistributor: "distribuidora de medicamentos",
      drugActiveingridents: "Ingredientes ativos de medicamentos",
      drugSubstitutionId: "ID de Substituição de Medicamentos",
      packId: "ID do pacote",
      packBatchNumber: "Número do lote da embalagem",
      drugIdStatement: "O número do lote do medicamento.",
      drugNameSatement: "A marca anunciada sob a qual o medicamento é vendido.",
      drugGenericnameStatement: "A composição química de um medicamento, em vez da marca anunciada sob a qual o medicamento é vendido.",
      drugFormateSatement: "O número do lote do medicamento.",
      drugDozecalfSatement: "Saber a quantidade de dose de medicamento para o bezerro.",
      drugDozedamStatement: "Para saber a quantidade de dose de droga para represar.",
      drugManufacturerStatement: "Detalhes do fabricante do medicamento.",
      drugDistributorStatement: "Detalhes do distribuidor de drogas.",
      drugRegistrationdateStatement: "Data de registro do medicamento no país específico.",
      drugActiveingridentsStatement: "Lista dos ingredientes ativos.",
      drugSubstitutionIdStatement: "IDs de possíveis substituições para o medicamento no caso de o medicamento principal não estar disponível no momento.",
      packIdStatement: "Código de barras ou RF ID da embalagem.",
      packBatchNumberStatement: "O número do lote atribuído à embalagem pelo fabricante.",
      locationWarehouseID: "ID do depósito de localização",
      locationWarehouseIDState: "ID do armazém onde a embalagem está armazenada.",
      locationRackID: "Identificação do Rack de Localização",
      locationRackIDStatement: "ID do rack onde o pacote é armazenado.",
      locationTierID: "ID da camada de localização",
      locationTierIDStatement: "ID da camada no rack onde o pacote é armazenado.",
      locationPositionID: "ID da posição do local",
      locationPositionIDStatement: "ID da posição em uma camada onde o pacote está armazenado.",
      storageTemperatureCondition: "Condição de temperatura de armazenamento",
      storageTemperatureConditionStats: "Condição de armazenamento da embalagem.",
      containerForm: "Formulário de contêiner",
      containerFormStatement: "Forma de recipiente em que a droga foi acondicionada.",
      consistQuantity: "Quantidade composta",
      consistQuantityStatement: "Quantidade de comprimidos, frascos, etc na embalagem.",
      releaseId: "ID da versão",
      releaseIdStatement: "ID atribuído após o pacote ser levado pelo fazendeiro.",
      releaseDate: "Data de lançamento",
      releaseDateStatement: "Data em que a embalagem foi retirada do estoque pelo produtor.",
      packManufacturedDate: "Data de fabricação da embalagem",
      packManufacturedDateStatement: "Data em que a embalagem foi fabricada.",
      packImportedDate: "Data de Importação do Pacote",
      packImportedDateStatement: "Data em que o pacote foi importado.",
      packExpirationDate: "Data de vencimento do pacote",
      packExpirationDateStatement: "Data em que o pacote expirou.",
      expiredSoonFlag: "Sinalizador de expirado em breve",
      expiredSoonFlagState: "Aviso sobre o pacote expirando em breve.",
      packTotalVolumeLeft: "Volume total restante da embalagem",
      packTotalVolumeLeftState: "Número total de embalagens com os mesmos ingredientes que ficaram em estoque.",
      packOrderID: "ID do pedido do pacote",
      packOrderIDState: "ID que foi atribuído após o pedido do pacote do distribuidor.",
      packQuantityOrdered: "Quantidade do pacote encomendado",
      packQuantityOrderedState: "Número de embalagens encomendadas ao distribuidor.",
      packPrice: "Preço do Pacote",
      packPriceStatement: "Preço do pacote.",
      priceCurrency: "Moeda do preço",
      packPricecurrency: "Moeda do preço do pacote",
      packPricecurrencyState: "Nome da moeda em que o preço é nomeado.",
      packPaydate: "Data de pagamento do pacote",
      payDate: "Data de pagamento",
      packPaydateState: "Data em que o pagamento foi liberado para a distribuidora.",
      packShippingID: "ID de envio do pacote",
      shippingID: "ID de envio",
      packShippingIdState: "Identificação de envio da embalagem quando chega do distribuidor.",
      packShippingDate: "Data de envio do pacote",
      shippingDate: "Data de envio",
      packShippingDateState: "Data de chegada da embalagem ao stock.",
      packOrderStatus: "Status do pedido de embalagem",
      packOrderStatusState: "Status do pedido atual.",
      recepientKeeperId: "Identificador do Receptor",
      recepientKeeperIdStatement: "O nome do indivíduo/organização que recebeu o pacote.",
      recepientFarmId: "ID da fazenda receptora",
      recepientFarmIdStatement: "Identificação da fazenda a que pertence o receituário do medicamento animal.",
      recepientAnimalId: "ID do animal receptor",
      recepientAnimalIdState: "Identificação do animal para o qual o medicamento (embalagem) foi prescrito.",
      specialistComments: "Comentários do especialista",
      specialistCommentsState: "Comentários do especialista/veterinário sobre a prescrição.",
      specialistName: "Nome do especialista",
      specialistNameState: "Nome do especialista/veterinário que prescreveu o medicamento.",
      specialistID: "ID do especialista",
      specialistIDState: "Identificação do especialista/veterinário que prescreveu o medicamento.",
      reservedByKeeperId: "Reservado pelo ID do Guardião",
      reservedByKeeperIdState: "ID do detentor de quem reservou o pacote.",
      reservedByFarmId: "Reservado por ID da Fazenda",
      reservedByFarmIdState: "ID da fazenda para a qual reservou o pacote.",
      reservationTimeoutDate: "Data limite de reserva",
      reservationTimeoutDateState: "Data em que a reserva será cancelada automaticamente caso o pack não seja adquirido.",
      reservationTimeout: "Tempo Limite da Reserva",
      reservationTimeoutState: "Número de horas após o qual a reserva será automaticamente cancelada se o pacote não for comprado ou levado",
      reservationDate: "Data da reserva",
      reservationDateState: "Data de reserva do pacote.",
      reservationStatus: "Status da reserva",
      reservationStatusState: "Status da reserva do pacote. ",
      loadingDrugsPleaseWait: "Carregando Drogas... Por favor, aguarde",
      quantityOrder: "Pedido de quantidade",
      keeperID: "ID do detentor",
      timeoutDate: "Data limite",
      warehouseID: "ID do Armazém",
      rackID: "Rack ID",
      tierID: "ID da camada",
      positionID: "ID da posição",
      temperatureCondition: "Condição de temperatura",
      manufactureDate: "Data de fabricação",
      importedDate: "Data de Importação",
      totalVolumeLeft: "Volume Total Esquerdo"
    },
    reports: {
      myReports: "Meus relatórios",
      satelliteReports: "Relatórios de satélite",
      weatherReports: "Previsões do tempo",
      pregnancyAnalytics: "Analítica da Gravidez",
      semenEmbroyAnalytics: "Análise de sêmen/Embroy",
      semenAnalytics: "Análise de sêmen",
      embryoAnalytics: "Análise de embriões",
      calfAnalytics: "Calf Analytics",
      milkProduction: "Produção de Leite",
      totalMilkType: "Tipo de Leite Total",
      totalAnimalAnalytics: "Análise total de animais",
      animalAnalytics: "Análise Animal",
      analyticsAndReporting: "Análise e relatórios",
      filterByCountry: "Filtrar por país",
      filterByFarm: "Filtrar por fazenda",
      filterByRegion: "Filtrar por região",
      filterByMonth: "Filtrar por mês",
      filterByDate: "Filtrar por data",
      filterByRole: "Filtrar por função",
      filterByYear: "Filtrar por ano",
      filterByTrait: "Filtrar por característica",
      avgBreedingValue: "Valor médio de reprodução",
      avgEconomicIndex: "Índice Econômico Médio",
      breederReport: "Relatório do Criador",
      semenTransferDate: "Data de transferência de sêmen",
      semenEmbryoProductionReport: "Relatório de Produção de Sêmen/Embriões",
      semenProducts: "Produtos de sêmen",
      meatProducts: "Produtos de carne",
      totalProducts: "Produtos totais",
      semenEmbryoReport: "Relatório de sêmen/embrião",
      numOfStraws: "Número de Canudos",
      collectionDate: "Data de Coleta",
      productionReport: "Relatório de Produção",
      receipientId: "ID do destinatário",
      embryoId: "ID do embrião",
      semenStrawId: "ID da palha de sêmen",
      dataScientist: "cientista de dados",
      dataScientistReport: "Relatório do Cientista de Dados",
      productReport: "Relatório do produto",
      dairyProducts: "Lacticínios"
    },
    genoPerformance: {
      performanceOfGenoType: "Desempenho do GenoType",
      addAGenoType: "Adicionar um GenoTipo",
      breedName: "Nome da raça",
      chromosome: "Cromossoma",
      sequenceChange: "Mudança de sequência",
      inheritance: "Herança",
      diseaseName: "Nome da doença",
      referenceSequence: "Sequência de Referência",
      pubmedReference: "Referência Pubmed",
      genoTypeRegistration: "Registro de Genotipo",
      breed: "Raça",
      editAGenoType: "Editar um GenoType",
      editGenoType: "Editar GenoTipo",
      loadingGene: "Carregando Geno... Por favor, aguarde",
      geneTypeList: "Lista de Genotipos"
    },
    reportings: {
      conception: "Concepção (Cientista de Dados)",
      performanceOfGenoData: "Desempenho do Genótipo (Cientista de Dados)",
      totalInsemination: "Inseminação Total",
      embryo: "Embrião",
      animalVaccinationRecord: "Boletim de Vacinação Animal",
      dataNotAvailable: "Os dados não estão disponíveis para esta Fazenda.",
      pregnancyStatus: "Estado de Gravidez",
      healthReport: "Relatório de saúde",
      heavyMilk: "Leite Pesado",
      standardMilk: "Leite Padrão"
    },
    sidebar: {
      healthAnalytics: "Análise de saúde",
      productionAnalytics: "Análise de produção"
    },
    epd: {
      regNo: "Animal Reg No é o código único dado ao animal usando um meio de marcação, garantindo um processo feito para identificar e rastrear animais específicos",
      internationalID: "Identificação Internacional de Animal",
      location: "País/Região de Nascimento do Animal ",
      animalName: "Nome Padrão / Nomenclatura do Animal",
      gender: "Sexo do animal (macho/fêmea)",
      additionalIDMethod: "Que método foi usado para identificar o animal (por exemplo, brinco, tatuagem)",
      damID: "ID ou número de registro da mãe do animal - a mãe de um animal/ID do número da mãe biológica",
      sireId: "Um número de identificação ou registro do progenitor masculino de um animal, especialmente um touro mantido para reprodução ou sêmen de touro usado para Inseminação Artificial.",
      dateOfBirth: "Data de nascimento do animal.",
      breederHerdCode: "Código de Rebanho de Criadores fornecido principalmente por Associações de Criadores",
      seasonofBirth: "Época de nascimento do animal anotada em meses",
      birthYear: "O ano em que o animal nasceu",
      birthManagementCode: "Código de gerenciamento de nascimento fornecido principalmente pelo usuário/agricultor",
      birthSex: "Sexo do animal (macho/fêmea)",
      birthWeight: "Peso ao Nascer do Bezerro ",
      primaryBreed: "Maior % Contribuição genética do animal ",
      secondaryBreed: "Menor % Contribuição genética do animal ",
      breedComposition: "A porcentagem de composição da raça refere-se à representação proporcional de diferentes raças dentro da composição genética de um animal individual ou de um grupo de animais. ",
      conceptionMethod: "Como o animal foi concebido (colocação natural/inseminação/transferência de embrião).",
      accuracyWeight: "Peso de precisão",
      damAge: "A idade da barragem em meses/anos, por ex. ",
      weaningWeight: "Desmame Peso do animal no momento do desmame.",
      weaningDate: "A data em que o animal foi desmamado",
      weaningSex: "O sexo do animal que foi desmamado. ",
      managementPastureCode: "Código dado ao manejo/pasto pelo usuário/agricultor ",
      creep: "Creepfeeding é a prática de fornecer alimentação suplementar (grãos ou forragem) para bezerros lactantes.",
      weaningContemporaryGroupCode: "Código de Desmame Peso Grupo Contemporâneo",
      birthContemporaryCode: "Código Contemporâneo de Nascimento",
      yearlingDate: "Data do animal com um ano de idade ou no segundo ano de idade",
      managementFeedUnitCode: "Código fornecido à unidade de gerenciamento/alimentação pelo usuário",
      yearlingSex: "O sexo do animal no momento do sobreano ",
      yearlingWeight: "O peso de um ano é uma medida do crescimento direto pós-desmame e é frequentemente usado para refletir o desempenho potencial da progênie destinada ao mercado no confinamento, medido em quilos de bezerro.",
      yearlingHeight: "Altura do animal no momento do sobreano ",
      yearlingWeightContemporaryGroupCode: "Código de Grupo Contemporâneo de Peso de Ano Novo",
      weaningYearlingWeightContemporaryGroupCode: "código do Grupo Contemporâneo de Desmame ou Sobreano",
      daysOnFeed: "Número de dias alimentados com aquela ração específica Ex: bovinos jovens em crescimento são alimentados com uma dieta de alta energia para produzir carne comercializável com baixo custo de ganho. ",
      managementFeedUnitPenCode: "Código fornecido à unidade de gerenciamento/alimentação/curral pelo usuário",
      harvestDate: "Data do animal abatido ( morto ) para carne",
      gradingDate: "A data das carcaças foi classificada de acordo com um critério específico",
      carcassSex: "sexo da carcaça",
      dateonFeed: "Data em que o animal foi transferido para uma nova ração Ex: gado jovem em crescimento é alimentado com uma dieta de alta energia para produzir carne comercializável com baixo custo de ganho. ",
      KPH: "% KPH é a porcentagem de gordura total encontrada na cavidade corporal de uma carcaça especificamente nas regiões dos rins, pelve e coração. ",
      carcassWeight: "O peso da carcaça é o peso quente ou não refrigerado após a colheita e remoção do couro, cabeça, trato gastrointestinal e órgãos internos. ",
      fatThickness: "A espessura da gordura é medida em polegadas usando uma pequena régua. ",
      marbling: "O marmoreio é a gordura intramuscular insaturada visível (saudável) que se acumula dentro do músculo e entre os feixes de fibras musculares.",
      ribeyeArea: "Quantidade de área de olho de lombo (lombo ou músculo longissimus dorsi) medida entre a 12ª e 13ª costelas em polegadas quadradas usando uma grade (por exemplo, 8, 9 ou 10 polegadas). ",
      animalStatus:"Status do animal na fazenda, por exemplo: na fazenda, vendido, morto, etc."
    },
    manageAnimalGroupings: {
      resetModeTooltip: "MODO DE REINICIALIZAÇÃO <br> neste modo <br> 1) Definir/definir todas as características dos grupos contemporâneos (GCs) para todos os traços de interesse. <br> 2) Atribua todos os animais a um CG correspondente. <br> 3) Se a atribuição dos animais não for satisfatória, ajuste/altere os CGs e, em seguida, atribua novamente os animais aos novos CGs correspondentes. <br> 4) Repita os passos acima, se necessário, até que esteja satisfeito com os CGs e agrupamento/designação de animais correspondente.<br>",
      maintainanceModeHeadingTooltip: "Uma vez finalizado o RESET (modo), você entrará no MODO DE MANUTENÇÃO onde os EDPs calculados no RESET serão mantidos constantes para cada animal até o próximo RESET (que pode demorar de 2 a 6 meses). ",
      maintainanceModeTooltip: "Depois de concluir o RESET MODE, pressione o botão RESET FINALIZED para permitir que o sistema calcule as DEPs de todos os animais, encerre o RESET MODE e inicie o MANUTENANCE MODE.",
      resetToggleTooltip: "Habilite Reset Toggle na configuração do modelo EPD para atribuir animais a CGs."
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "Genética",
      geneticSearchTool: "Ferramenta de Pesquisa Genética",
      dataSubmission: "Envio de dados",
      animalsWithExpectedProgenyDifferences: "Animais com diferenças esperadas na progênie (EPDs)",
      searchByAnimalIdName: "Pesquise por ID do animal, nome",
      rowsPerPage: "Linhas por página",
      individualEntry: "Entrada Individual",
      bulkEntry: "Entrada em massa",
      registerANewAnimalOrSelectAnExistingAnimal: "Registre um novo animal ou selecione um animal existente.",
      registerNewAnimal: "Registrar Novo Animal",
      selectExistingAnimal: "Selecionar Animal Existente",
      animalID: "Identificação do animal",
      animalName: "Nome do animal",
      tag: "Marcação",
      dateOfBirth: "Data de nascimento",
      gender: "Gênero",
      birthDate: "Data de nascimento",
      birthWeightLb: "Peso ao Nascer (lb)",
      birthWeightKg: "Peso ao Nascer (kg)",
      weaningWeightLb: "Peso de Desmame (lb)",
      weaningWeightKg: "Peso Desmame (kg)",
      yearlingWeightLb: "Peso de um ano (lb)",
      yearlingWeightKg: "Peso de um ano (kg)",
      carcassWeightLb: "Peso da Carcaça (lb)",
      carcassWeightKg: "Peso da Carcaça (kg)",
      animalSelection: "Seleção de Animais",
      animalSearchTool: "Ferramenta de pesquisa de animais",
      back: "Voltar",
      searchByEPDs: "Pesquisar por EPDs",
      searchByIds: "Pesquisar por IDs",
      selectBreed: "Selecione a raça",
      selectGender: "Selecione o gênero",
      selectRequiredBreedForCattle: "Selecione a raça necessária para o gado",
      resetFilter: "REINICIALIZAR FILTRO",
      birthWeightHeader: "Peso ao Nascer (PC): ",
      birthWeightDef: "Compara as diferenças no peso dos bezerros ao nascer e é medido em libras ou kg.",
      weaningWeightHeader: "Peso ao Desmame (WW): ",
      weaningWeightDef: "WW EPD é uma estimativa do crescimento pré-desmame que é medido em libras ou kg.",
      yearlingWeightHeader: "Peso de um ano (YW): ",
      yearlingWeightDef: "YW EPD é uma estimativa do crescimento pós-desmame que é medido em libras ou kg.",
      ribEyeAreaHeader: "Área de olho de lombo (REA): ",
      ribEyeAreaDef: "O REA mede o tamanho do músculo que nos dá o olho de lombo em polegadas quadradas. As DEPs do REA refletem as diferenças em uma medição ajustada da área de olho de lombo de 365 dias com base nas medidas de carcaça de gado abatido.",
      marblingHeader: "Marmorização (MARB): ",
      marblingDef: "O MARB DEP está em unidades de porcentagem de gordura intramuscular dentro do olho de lombo. MARB DEP refletem diferenças em uma pontuação de marmoreio de 365 dias ajustada (gordura intramuscular, [IMF]) com base nas medidas de carcaça de gado abatido.",
      fatThicknessHeader: "Espessura de gordura (GORD): ",
      fatThicknessDef: "Polegadas de toucinho (em centésimos de polegada) é a unidade de medida para FT.",
      carcassWeightHeader: "Peso da Carcaça (CW): ",
      carcassWeightDef: "O peso da carcaça é uma característica benéfica quando se considera o impacto que os quilos têm em relação ao valor do produto final. ",
      yieldGradeHeader: "Grau de Rendimento (YG): ",
      yieldGradeDef: "O sistema de pontuação USDA Yield Grade é a unidade de medida para o YG EPD. ",
      milkHeader: "Leite (MK): ",
      milkDef: "O MK DEP é medido em quilos de peso ao desmame do bezerro devido à capacidade de ordenha de sua mãe.",
      totalMaternalHeader: "Total Maternal(TM): ",
      totalMaternalDef: "O TM mede o impacto no peso ao desmame do bezerro devido à produção de leite e à genética da vaca para crescimento.",
      calvingEaseDirectHeader: "Facilidade de Parto Direta (CED): ",
      calvingEaseDirectDef: "O CED EPD é listado como uma porcentagem de partos não assistidos.",
      calvingEaseMaternalHeader: "Facilidade de Parto Maternal (CEM): ",
      calvingEaseMaternalDef: "Mede a capacidade das filhas de um touro de parir sem ajuda aos dois anos de idade.",
      stayabilityHeader: "Permanência (STAY): ",
      stayabilityDef: "O ST DEP prevê a capacidade de um touro gerar vacas que “permanecem por perto”. ",
      docilityHeader: "Docilidade (DOC): ",
      docilityDef: "O DOC mede o temperamento do gado.",
      max: "MAX",
      min: "MIN",
      accuracy: "PRECISÃO",
      sortBy: "Ordenar por",
      traits: "As características exibidas em cinza estão em desenvolvimento, chegando no segundo trimestre de 2023.",
      searchResults: "Procurar Resultados",
      recordsFound: "registros encontrados",
      compareSelected: "COMPARAR SELECIONADOS",
      animalIdentification: "Identificação de Animais",
      errorMessage: {
        birthWeight: "O valor máximo do peso ao nascer não pode ser inferior ao peso mínimo ao nascer",
        weaningWeight: "O valor máximo do peso à desmama não pode ser inferior ao peso mínimo à desmama",
        yearlingWeight: "O valor máximo do peso de um ano não pode ser menor que o peso mínimo de um ano",
        carcassWeight: "O valor máximo do peso da carcaça não pode ser inferior ao mínimo do peso ao nascer",
        fatThickness: "O valor máximo da Espessura de Gordura não pode ser menor que o mínimo de Peso de Desmame",
        marbling: "O valor máximo de marmoreio não pode ser inferior ao peso mínimo de um ano",
        ribeyeArea: "O valor máximo da Área Ribeye não pode ser inferior ao peso mínimo ao nascer",
        yieldGrade: "O valor máximo do Yield Grade não pode ser menor que o peso mínimo de desmame"
      },
      reg: "Registro",
      name: "Nome",
      sex: "Sexo",
      tattoo: "Tatuagem",
      dob: "DOB",
      EPD: "EPD",
      rank: "Classificação",
      searchValue: "Pesquisar Valor",
      typeHere: "Digite aqui",
      searching: "Procurando...",
      fetchingResult: "Obtendo resultados... Aguarde",
      animalsMatchedYourCriteria: "Os animais correspondem aos seus critérios",
      manageAnimalsGrouping: "Gerenciar agrupamento de animais",
      manageAnimalGroupings: "Gerenciar agrupamentos de animais",
      assignAnimalToContemporaryGroups: "Atribuir animais a grupos contemporâneos",
      resetMode: "Modo de reinicialização",
      enterResetMode: "Entrar no modo de redefinição",
      maintainanceMode: "Modo de manutenção",
      assigningAnimals: "Atribuição de animais",
      excludedAnimals: "Animais Excluídos",
      ungroupedAnimals: "Animais não agrupados",
      assignAnimalsToCGS: "Atribuir Animais ao CGS",
      reset: "Reiniciar",
      excludeAnimals: "Excluir animais",
      resetToMaintainanceMode: "Redefinição finalizada - Mude para o modo de manutenção",
      contemporaryGroupsSettings: "Configurações de Grupos Contemporâneos (CG)",
      selectTrait: "Selecione Característica",
      selectTraitDescription:"Selecionar característica refere-se ao processo de escolha de uma característica específica",
      traitsType: {
        birthWeight: "Peso ao nascer",
        weaningWeight: "Peso Desmame",
        yearlingWeight: "Peso de um ano",
        carcassWeight: "Peso da Carcaça"
      },
      addNewGroup: "ADICIONAR NOVO GRUPO",
      contemporaryGroup: "Grupo Contemporâneo",
      contemporaryGroups: "Grupos Contemporâneos",
      editGroup: "Editar grupo",
      birthCGCode: "Código de nascimento (CG)",
      groupName: "Nome do grupo",
      birthSex: "Nascimento Sexo",
      conceptionMethod: "Método de concepção",
      weaningCGCode: "Código de Desmame (CG)",
      yearlingCGCode: "Código de ano de idade (CG)",
      dateWeight: "Data Peso",
      weaningyearlingCGcode: "Código de desmame/sobreano (CG)",
      carcassCGCode: "Código da Carcaça (CG)",
      breedOfDom: "raça de represa",
      addNewContemporaryGroup: "Adicionar novo grupo contemporâneo",
      createNewGroup: "Criar novo grupo",
      selectFromDifferentTraits: "Selecione entre diferentes características",
      contemporaryGroupName: "Nome do Grupo Contemporâneo",
      enterNameHere: "Digite o nome aqui",
      groupNameIsRequired: "O nome do grupo é obrigatório",
      birthYearRange: "Faixa de ano de nascimento",
      theYearAnimalWasBorn: "O ano em que o animal nasceu",
      birthYearIsRequired: "O Ano de Nascimento é obrigatório",
      genderOfNewBornAnimal: "sexo do animal recém nascido",
      selectSex: "Selecione o sexo",
      theweightOfAnimalAtBirth: "O peso do animal ao nascer",
      maximumKg: "Máximo",
      minimumKg: "Mínimo",
      aSeasonisAPeriodOfYear: "Uma estação é um período do ano que se distingue por condições climáticas especiais.",
      seasonofBirthIsRequired: "A época de nascimento é obrigatória",
      majorGenericContributionOfAnimal: "Maior % de contribuição genérica de animal",
      primaryBreedCompostionIsRequired: "A composição da raça primária é necessária",
      secondaryBreedCompostionIsRequired: "A composição da raça secundária é necessária",
      howTheAnimalWasConceived: "Como o animal foi concebido (colocação natural/inseminação/transferência de embrião)",
      conceptionMethodIsRequired: "O método de concepção é obrigatório",
      epdModelSettings: "Configurações do modelo EPD",
      forResetMode: "Para o modo de reinicialização",
      progenyWeightingFactor: "Fator de Ponderação da Progênie",
      weightGivenToTheProgenyFactor: "Peso dado ao fator de progênie em relação ao fator CG para cálculo de DEP no modo Reset. ",
      enterNumber: "Insira numeros",
      enterBreed: "Insira a raça",
      valueShouldBeBetween0and1: "O valor deve estar entre 0 e 1",
      resetDuration: "Redefinir duração",
      timeIntervalBetweenLastAndFirstResetMode: "Intervalo de tempo entre o último e o novo modo de reinicialização, ao final do qual o novo modo de reinicialização é habilitado e novos CGs e EPDs são calculados.",
      enterNumberOfDays: "Digite o número de dias",
      valueCannotBeNegative: "O valor não pode ser negativo!",
      criticalProgenyPopulation: "População Crítica de Progênie",
      minimumNumberOfProgenyRecords: "Número mínimo de registros de progênie do animal individual no sistema necessário para atingir a Precisão de Progênie (APD1) acima de 50% (para Precisão de Pedigree)",
      criticalAncestorPopulation: "População ancestral crítica",
      minimumNumberOfAncestorsRecords: "Número mínimo de registros de ancestrais do animal individual no sistema necessário para atingir a Precisão de Antepassados ​​(APD4) acima de 50% (para Precisão de Pedigree)",
      forBirthWeightCG: "Para Peso ao Nascer CG",
      criticalPopulationInAnimalsContemporaryGroup: "População Crítica no Grupo Animal's Contemporary",
      minimumAverageNumberOfAnimalsPerBirthWeight: "Número médio mínimo de animais por CG de peso ao nascer necessário para atingir a Precisão Média do CG (ACG3) acima de 50%",
      criticalAveragePopulationPerContemporaryGroup: "População média crítica por grupo contemporâneo",
      minimumNumberOfAnimalsInBirthWeight: "Número mínimo de animais no CG de peso ao nascer do animal necessário para atingir a precisão do CG (ACG2) acima de 50%",
      forWeaningWeightCG: "Para Desmame Peso CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "Número médio mínimo de animais por CG de peso à desmama necessário para atingir a precisão média do CG (ACG3) acima de 50%",
      minimumNumberOfAnimalsInWeaningWeight: "Número mínimo de animais no CG de peso à desmama do animal necessário para atingir a precisão do CG (ACG2) acima de 50%",
      forYearlingWeightCG: "Para peso de um ano CG",
      minimumAverageNumberOfAnimalsPerYearling: "Número médio mínimo de animais por CG de um ano necessário para atingir a precisão média do CG (ACG3) acima de 50%",
      minimumNumberOfAnimalsInYearlingWeight: "Número mínimo de animais no CG de Peso ao Ano do animal necessário para atingir a Precisão do CG (ACG2) acima de 50%",
      forCarcassCG: "Para Carcaça CG",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "Número médio mínimo de animais por CG de peso de carcaça necessário para atingir a Precisão Média do CG (ACG3) acima de 50%",
      minimumNumberOFAnimalInCarcassWeight: "Número mínimo de animais no CG do peso da carcaça do animal necessário para atingir a Precisão do CG (ACG2) acima de 50%",
      epdRequiredFieldSettings: "Configurações de Campo Exigidas de EPD",
      pleaseSelectRequiredFieldsForCompleteEPD: "Por favor, selecione os campos obrigatórios para um cálculo EPD completo",
      byDefault: "Por padrão",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "Observação: observe que os usuários não poderão obter o cálculo completo da EPD se não fornecerem os campos de dados marcados como obrigatórios.",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "Observação: Observe que os parâmetros de campo obrigatórios não podem ser alterados, pois já existem grupos contemporâneos em relação aos parâmetros anteriores.",
      noResultFound: "NENHUM RESULTADO ENCONTRADO",
      next: "Próximo",
      cancel: "Cancelar",
      selectAnimal: "Selecione Animal",
      searchBy: "Procurar por",
      breed: "Raça",
      regDate: "Reg. ",
      status: "Status",
      animalDetails: "Detalhes do animal",
      add: "Adicionar",
      update: "Atualizar",
      dataForEPDs: " Dados para EPDs",
      basicInformation: "Informação básica",
      birthWeightInformation: "Informações sobre peso ao nascer",
      weaningWeightInformation: "Informação de peso ao desmame",
      yearlingWeightInformation: "Informações de peso de um ano",
      carcassWeightInformation: "Informações de Peso da Carcaça",
      delete: "Excluir",
      deleteEpdData: "Excluir dados EPD",
      areYouSureYouWantToDeleteEpdData: "Tem certeza de que deseja excluir os dados EPD.",
      internationalID: "Identificação internacional",
      enterID: "Digite a ID",
      animalRegistration: "Registro de Animais",
      location: "Localização",
      additionalIDMethod: "Método de identificação adicional",
      damID: "ID da barragem",
      sireID: "ID do pai",
      breederHerdCode: "Código do rebanho criador",
      birthYear: "Ano de Nascimento",
      primaryBreed: "Raça Primária",
      breedComposition: "Composição da Raça",
      secondaryBreed: "Raça Secundária",
      seasonofBirth: "Temporada de Nascimento",
      birthManagementCode: "Código de gerenciamento de nascimento",
      damAge: "Dano",
      years: "Anos",
      birthContemporaryCode: "Código Contemporâneo de Nascimento",
      accuracyWeight: "Peso de precisão",
      note: "Observação",
      minimumRequiredFieldForBirthWeight: "Campo mínimo obrigatório para EPDs de peso ao nascer",
      birthYearGenderConceptionMethodBirthWeight: "Ano de Nascimento , Sexo , Método de Concepção , Peso ao Nascer",
      weaningWeight: "Peso Desmame",
      weaningDate: "Data de Desmame",
      weaningContemporaryGroupCode: "Código do Grupo Contemporâneo de Desmame",
      creep: "Rastejar",
      managementPastureCode: "Código de manejo/pastagem",
      weaningSex: "sexo de desmame",
      minimumRequiredFieldForWeaningWeight: "Campo mínimo obrigatório para DEPs de peso ao desmame",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "Peso à Desmama, Código de Manejo/Pasto, Sexo à Desmama, Data da Pesagem",
      yearlingWeight: "Peso de um ano",
      yearlingHeight: "Altura de um ano",
      yearlingDate: "Data de nascimento",
      yearlingContemporaryGroupCode: "Código do Grupo Yearling Contemporary",
      managementFeedingCode: "Código de gerenciamento/alimentação",
      yearlingSex: "Sexo de um ano",
      youWillNeedToFillOutFor: "Você precisará preencher todos os campos para recuperar dados EPD para",
      pleaseSelectHavestDateFirstToEnterInfo: "Por favor, selecione 'Data de Colheita' primeiro para inserir informações para Área de Rib Eye, Espessura de Gordura e Marmoreio",
      harvestDate: "Data da Colheita",
      dateOnFeed: "Data no feed",
      daysOnFeed: "Dias na alimentação",
      gradingDate: "Data de avaliação",
      carcassSex: "Sexo da Carcaça",
      carcassWeight: "Peso da Carcaça",
      carcassContemporary: "Carcaça Contemporânea",
      damBreed: "Barragem",
      ribEyeArea: "Área do olho de lombo",
      ribEyeAreaContemporary: "Rib Eye Area Contemporânea",
      fatThickness: "Espessura de gordura",
      fatThicknessContemporary: "Gordura Espessura Contemporânea",
      marbling: "marmorização",
      marblingContemporary: "Marmorização Contemporânea",
      yieldGradeContemporary: "Yield Grade Contemporânea",
      animalsNotListedInContemporaryGroupsMsg: "Os animais não foram adicionados a nenhum grupo contemporâneo devido à falta de informações. ",
      listOfUngroupedAnimals: "Lista de Animais Não Agrupados",
      submittingData: "Enviando Dados",
      resendToUser: "Reenviar ao usuário",
      submittingAnimalsInGroupMsg: "Submetendo seus animais em grupos. ",
      pressingResetBtnMsg: "Pressionar o botão \"Redefinir\" iniciará um processo para reatribuir os animais aos seus grupos contemporâneos.",
      doYouWantToProceed: "Você quer prosseguir ?",
      systemMaintainanceModeMsg: "Pressionar o botão Alterar para Modo de Manutenção\" iniciará um processo e seu sistema entrará no \"MODO DE MANUTENÇÃO\" onde os EDPs calculados no RESET serão mantidos constantes para cada animal até o próximo RESET (que pode ser de 1 a 6 meses",
      errorFetchingContemporaryGrpMsg: "Erro ao buscar dados do grupo contemporâneo",
      deleteSuccess: "Excluir sucesso",
      deleteSuccessMsg: "Grupo contemporâneo excluído com sucesso.",
      deleteFailed: "Excluir falhou",
      deleteFailedMsg: "Erro ao excluir os dados do grupo contemporâneo",
      deleteContemporaryGrpMsg: "Tem certeza de que deseja excluir este grupo contemporâneo?",
      addBirthWeightData: "Adicionar dados de peso ao nascer",
      addWeaningWeightData: "Adicionar dados de peso de desmame",
      birthWeightContemporaryGroupCode: "Peso ao Nascer Código do Grupo Contemporâneo",
      dateWeighted: "Data Ponderada",
      addYearlingWeightData: "Adicionar dados de peso de um ano",
      addCarcassWeightData: "Adicionar Dados de Peso da Carcaça",
      weaningOrYearlingContemporaryGroupCode: "Desmame ou Peso de Sobreano Código do Grupo Contemporâneo",
      deleteContemporaryGroupMsg: "Tem certeza de que deseja excluir o grupo contemporâneo?",
      updateSuccessMsg: "Grupo contemporâneo atualizado com sucesso.",
      errorMsg: "Algo deu errado. ",
      fetchErrorMsg: "Erro ao buscar campos obrigatórios para a característica selecionada.",
      forMaintainanceMode: "Para o modo de manutenção",
      ancestorsWeightFactor: "Fator de Peso dos Ancestrais",
      weightGivenToTheAncestorFactor: "Peso dado ao fator ancestral em relação ao fator CG para cálculo de EPD no modo Manutenção. ",
      addEPDModelSettingsData: "Adicionar Dados de Configurações do Modelo EPD",
      minimumNumberOfAnimalsInContemporaryGroups: "Número Mínimo de Animais em Grupos Contemporâneos",
      enterNumberOfAnimals: "Digite o número de animais",
      areYouSureYouWantToChangeEPDCalculation: "Tem certeza de que deseja alterar os campos de cálculos EPD obrigatórios?",
      weightOfAnimalAtBirth: "Peso do Animal ao Nascer",
      seasonIsAPeriodOfYear: "Uma estação é um período do ano que se distingue por condições climáticas especiais.",
      codeOfBirthWeightContemporaryGroup: "Código do Grupo Contemporâneo Peso ao Nascer",
      weaningWeightOfCalf: "Peso ao Desmame do Bezerro",
      dateAnimalWasWeaned: "A data em que o animal foi desmamado",
      genderOfWeaningAnimal: "Sexo do Animal Desmamado",
      yearlingWeightOfCalf: "Peso do Bezerro ao Ano",
      dateAnimalWasWeighted: "A data em que o animal foi pesado",
      yearledAnimalSex: "O sexo do animal que foi parido",
      dateOfAnimalKilledForMeat: "Data do animal morto para carne",
      addSuccessMsg: "Grupo contemporâneo adicionado com sucesso",
      traitH: "A característica para cálculo de DEP.",
      searchByValue: "Insira o número de registro/tatuagem/nome/etiqueta"
    }
  }